import React, { useEffect, useMemo, useRef, useState } from "react";
import { Alert, Anchor, Button, Card, Col, Empty, Flex, Form, Input, List, message, Modal, notification, Progress, Row, Segmented, Space, Steps, Table, Tabs } from 'antd';
import type { TableProps, UploadFile } from 'antd';
import { BudgetDataInterface } from "../models/IBudgetData";
import { AboutResearchInterface } from "../models/IAboutResearch";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { formatNumber, isDateSelected, isNull, mapTypetoName, monthcolumn, periodToString } from "./functionLater";
import { FaPenNib } from "react-icons/fa6";
import { EducationInterface } from "../models/IEducation";
import { researcherInterface } from "../models/IUserData";
import { PublishedInterface } from "../models/IPub";
import { ShowUserInterface,CommentInterface } from "../models/IShowUser";
import { ResearchHistInterface } from "../models/IResearchHist";
import { joinedParticipantInterface } from "../models/IjoinedResearcher";
import { ImpactsInterface, OutcomeInterface, OutputInterface } from "../models/Result";
import JoditReact from "jodit-react";
import CkEditor from "./ckeditor/ckEditor";
import LoadingOverlay from 'react-loading-overlay-ts';
import TextArea from "antd/es/input/TextArea";
import { Editor } from '@ckeditor/ckeditor5-core'; // Import Editor type
import { stringify } from "jodit/esm/core/helpers";
import { Feather } from "lucide-react";
import moment from "moment";
import { useForm } from "antd/es/form/Form";
import { ExpandAltOutlined } from "@ant-design/icons";
import { exportHtmlToDocx, exportHtmlToPdf } from "./ckeditor/ExportAsDoc";



interface ColumnGroup {
  title: string;
  children: { title: string,render : any }[];
}

const educolumn : TableProps<EducationInterface>['columns']=[
    {
      title: 'ระดับปริญญา',
      dataIndex:'edu_level',
      key: 'edu_level'
  },
  {   title: 'วุฒิการศึกษา',
      dataIndex: 'edu_qual',
      key: 'edu_qual',
  },
  {
      title: 'สถาบันการศึกษา',
      dataIndex:'edu_name',
      key: 'edu_name'
  },
  {
    title: 'ปีที่สำเร็จการศึกษา',
    dataIndex:'edu_year',
    key: 'edu_year'
},
  {
      title: 'ประเทศ',
      dataIndex:'edu_country',
      key: 'edu_country'
  },
  ]
  

const headexcolumns: TableProps<ResearchHistInterface>['columns']=[
    {
        title: 'ปี พ.ศ.',
        dataIndex:'year',
        key: 'year'
    },
    {   title: 'ชื่อเรื่องวิจัย',
        dataIndex: 'project_name',
        key: 'project_name',
    },{
      title: 'สถานะในโครงการ',
      dataIndex: 'role',
      key: 'role',
    },
    {
        title: 'รายชื่อคณะวิจัย',
        dataIndex: 'join_project',
        key: 'join_project',
        width: 380,
        render: (_, record) => (
          <>
            {record.join_project.length != 0 &&
              <>
                <p>{record?.fullname}</p>
                {record.join_project.map((item) => (
                  <><p>{item.Per_FNameTH} {item.Per_LNameTH}</p></>
  
                ))}</> || <><Flex justify='center'>
                  <p>ไม่มีผู้ร่วมวิจัย</p></Flex>
              </>}
          </>
        ),
      },
    {
      title: 'แหล่งทุนสนับสนุน',
      dataIndex:'project_budget',
      key: 'project_budget',
      render: (_, record) => (
        <Space size="middle">
          {record.project_budget_type.inside!=null&&<p>{record.project_budget_type.inside}</p>}
          {record.project_budget_type.other!=null&&<p>{record.project_budget_type.other}</p>}
          {record.project_budget_type.student!=null&&<p>{record.project_budget_type.student}</p>}
      </Space>
      ),
  },
  ]

const academicHis : TableProps<PublishedInterface>['columns']=[
    {
        title: 'ปีที่พิมพ์',
        dataIndex:'year',
        key: 'year'
    },{
        title: 'ชื่อบทความทางวิชาการ',
        dataIndex:'academic_name',
        key: 'academic_name'
    },{
      title: 'ชื่อบทความทางวิชาการภาษาอังกฤษ',
      dataIndex:'academic_en_name',
      key: 'academic_en_name'
  },
    {
        title: 'ประเภทสิ่งตีพิมพ์',
        dataIndex:'academic_datebase',
        key: 'academic_datebase'
    },
  ]

interface Tab {
    key: string;
    label: string;
    children: React.ReactNode;
  }


export function BudgetReqInfo(){
  const { projectID } = useParams();
    const ref = useRef();
    const [Keys, setExpandedRowKeys] = useState<string[]>([]);
    const [isActive, setActive] = useState(false)
    const [User,setUser] = useState<researcherInterface>();
    const [DataFirst,setDataFirst] = useState<AboutResearchInterface[]>([]);
    const [responsibility,setResponsibility] = useState('')
    const [tmpType,setType] = useState(2)
    
    //part2 data
    const [HeadData,setHeadData] = useState<ShowUserInterface>()
    const [joinper,setjoinper] = useState(0)
    const [eduData,seteduData] = useState<EducationInterface[]>([])
    const [tmpeduData,settmpeduData] = useState<EducationInterface[]>([])
    const [checkResdata,setCheckResData]= useState(true)
    const [checkPubData,setCheckPubData]= useState(true)
    const [resData,setresData] = useState<ResearchHistInterface[]>([])
    const [pubData,setPubData] = useState<PublishedInterface[]>([])
    //studentList
    const [Studentfile, setStudentFile] = useState<UploadFile[]>([]);

    //part3
    const importantRef = useRef<Editor | null>(null);
    const objectiveRef = useRef<Editor | null>(null);
    const benefitRef = useRef<Editor | null>(null);
    const literatureRef = useRef<Editor | null>(null);
    const IdeaRef = useRef<Editor | null>(null);
    const ResearchRef = useRef<Editor | null>(null);
    const [selectedmonth,setselectedmonth] = useState(99)
    const [endmonth,setEndMonth] = useState(99)
    const [selectedyear,setselectedyear] = useState(9999)

    //part4
    const [Output,setOutput] = useState<OutputInterface[]>([])
    const [Outcome,setOutcome] = useState<OutcomeInterface[]>([])
    const [Impacts,setImpacts] = useState<ImpactsInterface>()
    
    //part5 
    const [compensationsum,setCompensationSum] = useState(0)
    const [compensationMonetry,setCompensationMonetrySum] = useState(0)
    const [compensationPrepared,setCompensationPreparedSum] = useState(0)
    const [compensationIndirect,setCompensationIndirectSum] = useState(0)
    const [outcomesum,setOutcomeSum] = useState(0)
    const [outcomeMonetry,setOutcomeMonetrySum] = useState(0)
    const [outcomePrepared,setOutcomePreparedSum] = useState(0)
    const [outcomeIndirect,setOutcomeIndirectSum] = useState(0)

    const [itemsum,setItemnSum] = useState(0)
    const [itemMonetry,setItemMonetrySum] = useState(0)
    const [itemPrepared,setItemPreparedSum] = useState(0)
    const [itemIndirect,setItemIndirectSum] = useState(0)
    const [compensationItems, setCompensationItems] = useState<BudgetDataInterface[]>([]);
    const [OutcomeItems, setOutcomeItems] = useState<BudgetDataInterface[]>([]);
    
  
    const [ItemCost, setItemCost] = useState<BudgetDataInterface[]>([]);
    const [toolDraft,setToolDraft] = useState(false);
    const [filename,setFilename] = useState('')
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [openfile,setOpenFile] = useState(false)
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);

    const [part2,setpart2] = useState(false)
    const [part3,setpart3] = useState(false)
    const [part4,setpart4] = useState(false)
    const [part5,setpart5] = useState(false)
    const [fundpart,setfundpart] = useState(false);
    const [editable,setEditable] = useState(true)
    const [status,setstatus]= useState(0)
    const [successprogress,SetSuccessProgress] = useState(0);
    const headCommentRef = useRef<Editor | null>(null);
    const [headComment,setheadcomment] = useState(false)
    const [headCommenttext,setheadcommenttext]  = useState('')
    const [headCommentdate,setheadcommentdate] = useState('')
    
    const [staffComment,setStaffComment] = useState(false)
    const staffCommentRef = useRef<Editor | null>(null);
    const [StaffCommenttext,setStaffcommenttext]  = useState('')
    const [StaffCommentDate,setStaffCommentDate] = useState('')
    const [showSum,setShowSum] = useState(false)
    const [showSumedit,setShowSumedit]= useState(false)
    const [SummaryComment,setSummaryComment]  = useState('')
    const [SumComment, setSumComment] = useState<CommentInterface[]>([]);
    const [reseacherComment,setResearcherComment] = useState('')

    const [openMod,setopenMod]=useState(false)
    const [preview,setPreview]=useState(false)
    const [loading, setLoading] = useState(false);
    const [checkexistparticipant,setexistparticipant] = useState(false);
    const [joinParticipant,setJoinParticipant] = useState<joinedParticipantInterface[]>([])


    const {ROCKEditors,CKEditors,getHTML} = CkEditor();
    const location = useLocation();
    const navigate = useNavigate();
    const [Explanation] = Form.useForm();
    const { project_id } = useParams();
    const htmlpage = useRef(null);
    const [PreviewLoading,setPreviewLoading] = useState(true);
    const [exportdata,setExportData] = useState('ss');

    const handleExpand = (expanded: boolean, record: any) => {
        
        if (expanded) {
            console.log(record.id)
            setExpandedRowKeys([record.id]); // Expand only the clicked row
        } else {
            setExpandedRowKeys([]); // Collapse all rows
        }
    };

    const handleExplanationChange = (value: string, rowIndex: number) => {
      const updatedData = [...SumComment];
      updatedData[rowIndex].explanation = value;
      setSumComment(updatedData);
    };

    const fetchFiles = async () => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_BASE}/files/${project_id}`);
          const files = response.data.map((file: any) => ({
            uid: file.uid || `__AUTO__${file.uid}`, // Ensure each file has a unique uid
            name: decodeURIComponent(atob(file.Filename)), // Decode the filename
            status: 'done', // Mark the file as already uploaded
            url: `${process.env.REACT_APP_BASE}/get_pdf/${file.uid}`, 
            preview: file.Data
          }));
          setFileList(files);
        } catch (error) {
          console.error('Error fetching file list:', error);
        }
      };

      const fetchStudentFiles = async () => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_BASE}/Studentfiles/${project_id}`);
          const files = response.data.map((file: any) => ({
            uid: file.uid || `__AUTO__${file.uid}`, // Ensure each file has a unique uid
            name: decodeURIComponent(atob(file.Filename)), // Decode the filename
            status: 'done', // Mark the file as already uploaded
            url: `${process.env.REACT_APP_BASE}/get_pdf/${file.uid}`, 
            preview: file.Data
          }));
          setStudentFile(files);
          console.log(files)
        } catch (error) {
          console.error('Error fetching file list:', error);
        }
      };

   
    const DownloadHandle = async (fileName: any) => {
        try {
          // Make API call to get the PDF data
          const response = await axios.get(`${process.env.REACT_APP_BASE}/get_pdf/${fileName}/${project_id}`, {
            responseType: 'blob', // This is crucial for handling binary data
          });
    
          // Create a Blob from the response
          const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
    
          // Create a URL for the Blob
          const pdfUrl = window.URL.createObjectURL(pdfBlob);
    
          // Create a link to download the PDF
          const link = document.createElement('a');
          link.href = pdfUrl;
    
          // Extract the filename from the Content-Disposition header
          const contentDisposition = response.headers['content-disposition'];
          let name = 'downloaded-file.pdf'; // Fallback filename
    
          if (contentDisposition) {
            const filenameRegex = /filename[^*=]*=((['"]).*?\2|([^;\s]*))/; 
            const matches = filenameRegex.exec(contentDisposition);
            if (matches != null && matches[1]) {
              name = matches[1].replace(/['"]/g, ''); // Remove quotes if present
            }
          }
    
          link.setAttribute('download', name); // Set the filename
    
          // Append link to body and trigger click to download
          document.body.appendChild(link);
          link.click();
    
          // Cleanup: remove link and release object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(pdfUrl);
    
          if(response.status === 200){
            message.success('Download File successfully');
          }else{
            message.error('ERROR, Download File unsuccessfully');
          }
    
          message.success('PDF downloaded successfully!');
        } catch (error) {
          console.error('Error downloading PDF:', error);
          message.error('Failed to download PDF.');
        } finally {
          setLoading(false);
        }
        // axios.get(`${process.env.REACT_APP_BASE}/get_pdf/${fileName}/${project_id}`).then(response=>{
        //     if(response.status === 200){
        //       message.success('Download File successfully');
        //     }else{
        //       message.error('ERROR, Download File unsuccessfully');
        //     }
        //   }
        // )
        
      };

      

  

      const handlePreview = (file: UploadFile) => {
        if (file.preview && (file.preview as any).data) {
          // Access the data array from the preview buffer
          const uint8Array = new Uint8Array((file.preview as any).data);
          const blob = new Blob([uint8Array], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);
      
          setPreviewUrl(blobUrl);
          setOpenFile(true);  // Open the modal
        } else {
          console.error("Preview data not found.");
        }
      };

    const send = () =>{
        
        let data = {
            part: "done",
        }
        if(status==2){
            data = {part: "edit-done",
            }
        }
        
        
        let comment = {
          comment:reseacherComment}

          const formValues = Explanation.getFieldsValue();
          const explanationsFromForm = formValues.SumComment || [];

        const updatedSumComment = SumComment.map((item, index) => ({
          ...item,
          explanation: explanationsFromForm[index]?.explanation || '',
        }));
        
      
        setSumComment(updatedSumComment);
         let dataSumcom ={
            status : 'รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่',
            comment : JSON.stringify(updatedSumComment),
            explanation : JSON.stringify(explanationsFromForm),
          }
          console.log(updatedSumComment)
          console.log(dataSumcom)
        
        axios.patch(`${process.env.REACT_APP_BASE}/UpdateBudgetReq/${project_id}`,data)
        .then((response)=>{
            if (response.status === 200) {
                console.log("บันทึกสำเร็จ")
                if(status!=0){
                axios.patch(`${process.env.REACT_APP_BASE}/comment/${project_id}`,comment)
                .then((res)=>{
                  if (res.status === 200){
                    if(status==3){
                      axios.post(`${process.env.REACT_APP_BASE}/summarysubmit/${project_id}`,dataSumcom)
                      .then(re => {
                        if (re.status === 200) {
                          sendComment();
                          navigate(`/VRIIS`);
                        }})}
                        else{
                          sendComment();
                          navigate(`/VRIIS`);
                        }
                    }
                })}else{
                    navigate(`/VRIIS`);
                }
                
            }
        }).catch((error)=>{
            console.log(error)
            notification.error({
                message: "บันทึกข้อมูลไม่สำเร็จ",
            });
        })
    }

    const sendComment = () =>{
      const formValues = Explanation.getFieldsValue();
      console.log(formValues.SumComment)

      const data ={
        comment:JSON.stringify(formValues.SumComment)
      }
      axios.patch(`${process.env.REACT_APP_BASE}/UpdateResearcherComment/${project_id}`,data).then((response)=>{
        if(response.status==200){
          notification.success({
            message: "บันทึกข้อมูลสำเร็จ",
        });
        }
      })


    }

    const expandedRowRender = (record: any) => {
      let dataSource:  any[] | undefined = [];
      let researcherFund = Math.min((Number(compensationMonetry)+Number(outcomeMonetry)+Number(itemMonetry)) * 0.3, 50000);
      
      if (record.category === 'compensation') {
        dataSource = compensationItems;
      } else if (record.category === 'outcome') {
        dataSource = OutcomeItems;
      } else if (record.category === 'itemexpense') {
        dataSource = ItemCost;
      }
    
      return (
        <Table
          columns={[
            {
              title: '',
              width: 92,
              dataIndex: 'id',
              key: 'id',
              render: (_, record) => (
                <Flex justify="center">
                  <p>{record.id !== 4 ? record.id : ''}</p>
                </Flex>
              ),
            },
            {
              title: '',
              width: 450,
              dataIndex: 'BudgetDetail',
              key: 'BudgetDetail',
            },
            {
              title: '',
              width: 1000,
              children: [
                {
                  title: '',
                  dataIndex: 'MonetrySum',
                  width:200,
                  render: (_, record) => (
                    <Flex justify="center">
                      {record.BudgetType === 'ตัวเงิน(เบิกจ่าย)'
                        ? formatNumber(record.Budget)
                        : '0'}
                    </Flex>
                  ),
                },
                {
                  title: '',
                  dataIndex: 'PreparedSum',
                  width:200,
                  render: (_, record) => (
                    <Flex justify="center">
                      {record.BudgetType === 'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้'
                        ? formatNumber(record.Budget)
                        : '0'}
                    </Flex>
                  ),
                },
                {
                  title: '',
                  dataIndex: 'IndirectSum',
                  width:200,
                  render: (_, record) => (
                    <Flex justify="center">
                      {record.BudgetType === 'ไม่เป็นตัวเงิน(งบอ้อม)'
                        ? formatNumber(record.Budget)
                        : '0'}
                    </Flex>
                  ),
                },
              ],
            },
            {
              title: '',
              width: 150,
              dataIndex: 'sum',
              render: (_, record) => (
                <Flex justify="center">{formatNumber(record.Budget)}</Flex>
              ),
            },
            {
              title: '',
              dataIndex: 'note',
              key: 'note',
              render: (text) => (
                <div style={{ maxWidth: '500px'}}>
                  {text}
                </div>
              ),
            },
          ]}
          dataSource={dataSource}
          pagination={false}
          rowKey="budgetid"
          locale={{
            emptyText: <Empty description="ไม่มีข้อมูลรายละเอียด" />,
          }}
          showHeader={false} // Hide headers in the expanded table
        />
      );
    };
    
    
    const config = useMemo(() => ({
        toolbar: false,
        readonly:true,
        minHeight: 100,
        inline: false,
        autoResize: true,
        showCharsCounter: false,
        showWordsCounter: false,
        showPoweredBy: false,
        placeholder: 'กรุณากรอกข้อความที่นี่...',
        disableDragAndDrop: false,
        resizer: {
          forImageChangeAttributes: true, // Enable image resizing attributes
        },
        uploader: {
          insertImageAsBase64URI: true, // Insert images as base64
        },
        table: {
          allowCellSelection: true,
          allowResizeColumn: true,
          allowResizeRow: true,
          useExtraClasses: true,
          selectionCellStyle: {
            backgroundColor: '#a8d8eb', // Style for selected table cells
          },
        },
        showXPathInStatusbar: false,
        image: {
          allowResizeX: true, // Allow horizontal image resizing
          allowResizeY: true, // Allow vertical image resizing
          forImageChangeAttributes: true
        },
        style: {
            allowStyle: true // Ensure inline styles like text alignment are allowed
          }
      }), []);
    
      const BudgetTypeCol = [
        {
          id: 1,
          detail: 'หมวดค่าตอบแทน',
          category:'compensation',
          sum:compensationsum,
          MonetrySum:compensationMonetry,
          PreparedSum:compensationPrepared,
          IndirectSum:compensationIndirect
        },
        {
          id: 2,
          detail: 'หมวดค่าใช้จ่าย',
          category:'outcome',
          sum:outcomesum,
          MonetrySum:outcomeMonetry,
          PreparedSum:outcomePrepared,
          IndirectSum:outcomeIndirect
        },
        {
            id: 3,
            detail: 'หมวดค่าวัสดุ และอุปกรณ์',
            category:'itemexpense',
            sum:itemsum,
            MonetrySum:itemMonetry,
            PreparedSum:itemPrepared,
            IndirectSum:itemIndirect
          },
          {
            id: 4,
            detail: 'รวม',
            category:'',
            sum:Number(itemsum)+Number(outcomesum)+Number(compensationsum),
            MonetrySum:Number(compensationMonetry)+Number(outcomeMonetry)+Number(itemMonetry),
            PreparedSum:Number(compensationPrepared)+Number(outcomePrepared)+Number(itemPrepared),
            IndirectSum:Number(compensationIndirect)+Number(outcomeIndirect)+Number(itemIndirect)
          }
      ];

    //ดึงข้อมูล
    const getUserData = async()=>{
        axios.get(`${process.env.REACT_APP_API}/get-researcher-team/${sessionStorage.getItem('user')}`).then(response => {
            setUser(response.data.userResult[0])
            settmpeduData(response.data.eduResult)
            if(response.data.projectResult.length>0||response.data.joinResult.length>0)
              {
                setCheckResData(false)
              }
            if(response.data.academicResult.length>0){
              setCheckPubData(false)
            }
        }).catch(error =>{console.log(error)})
    }
    //ดึงข้อมูลแบบ 2.0
    const getData = async() =>{
      await axios.get(`${process.env.REACT_APP_BASE}/BudgetReqInfo/${project_id}/${sessionStorage.getItem('user')}`).then(response=>{
      // axios.get(`${process.env.REACT_APP_BASE}/BudgetReqInfo/${project_id}/${sessionStorage.getItem('user')}`).then(response=>{
      setDataFirst(response.data.main)
      console.log(response.data)
        let percent = 0
        if (response.data.StaffComment.length>0){
          setStaffComment(true);
          setStaffcommenttext(response.data.StaffComment[0].comment)
        setheadcomment(true)
        if(response.data.StaffComment[0].date!=null){
          setStaffCommentDate(response.data.StaffComment[0].date)
        }
      }

      if(response.data.main[0].budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'){
        fetchStudentFiles();}
        if(response.data.main[0].Head_comment!=null){
          setheadcomment(true)
          setheadcommenttext(response.data.main[0].Head_comment)
        }else{setheadcomment(false)}
        if (response.data.head_researcher.length > 0) {
          setjoinper(Number(response.data.head_researcher[0].join_per));
        }
        if(response.data.main[0].Head_comment_date!=null){
          setheadcommentdate(response.data.main[0].Head_comment_date
          )
        }
        
        if (response.data.subInfo.length > 0) {
          const totalJoinPer = response.data.subInfo.reduce((sum: number, item: { join_per: any }) => sum + Number(item.join_per), 0);
          setjoinper((prevJoinPer) => Number(prevJoinPer) + Number(totalJoinPer));
        }
        
        if(response.data.main[0].reseachercomment){
          setResearcherComment(response.data.main[0].reseachercomment)
        }
        
            if(response.data.main[0].project_status=='แก้ไข'
            ){
                setEditable(true)
                setstatus(0)
            }else if(response.data.main[0].project_status=='รอตรวจสอบจากผู้บังคับบัญชาเบื้องต้น'){
                setstatus(1)
                setEditable(false)
            }else if(response.data.main[0].project_status=='สั่งแก้ไขจากผู้บังคับบัญชาเบื้องต้น'){
                setEditable(true)
                setstatus(1)
                setheadcomment(true)

                if (response.data.StaffComment.length>0){
                  setStaffcommenttext(response.data.StaffComment[0].Comment)
              }
            }else if(response.data.main[0].project_status=='รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย'){
                setstatus(2)
                setEditable(false)
                if (response.data.StaffComment.length>0){
                setheadcomment(true)}
            }
            else if(response.data.main[0].project_status=='สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย'){
                setstatus(2)
                setEditable(true)
                setStaffComment(true)
                if (response.data.StaffComment.length>0){
                setheadcomment(true)}
            }else if(response.data.main[0].project_status=='รอผลอนุมัติจากคณะกรรมการ'){
              setstatus(3)
              setEditable(false)
              if (response.data.StaffComment.length>0){
              setheadcomment(true)}
              setStaffComment(true)
              if(response.data.main[0].summary_comment){
                setShowSum(true)
              }
              // อนุมัติ
            }
            // รอการตรวจสอบผลอนุมัติจากกรรมการ
            else if(response.data.main[0].project_status=='รอการตรวจสอบผลอนุมัติจากกรรมการ'||
              response.data.main[0].project_status=='รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่'
            ){
              setstatus(3)
              setEditable(false)
              if (response.data.StaffComment.length>0){
              setheadcomment(true)}
              setStaffComment(true)
              // อนุมัติ
            }
            else if(response.data.main[0].project_status=='แก้ไขตามความเห็นของกรรมการ'||
              response.data.main[0].project_status=='สั่งแก้ไขตามความเห็นของกรรมการ'
            ){
              setstatus(3)
              setSumComment(JSON.parse(response.data.main[0].summary_comment).map((item: any) => ({
                ...item,
                explanation: "", 
              })))
              if (response.data.StaffComment.length>0){
              setheadcomment(true)}
              setEditable(true)
              setStaffComment(true)
              setShowSumedit(true)

              if(response.data.main[0].ResearcherSummaryComment&&response.data.main[0].ResearcherSummaryComment!=null){
                Explanation.setFieldValue('SumComment',JSON.parse(response.data.main[0].ResearcherSummaryComment))
              }

              // อนุมัติ
            }else if(response.data.main[0].project_status=='อนุมัติ'||response.data.main[0].project_status=='ไม่อนุมัติ'){
              setstatus(4)
              if (response.data.StaffComment.length>0){
              setheadcomment(true)}
              setSummaryComment(response.data.main[0].summary_comment)
              
              setShowSum(true)
              setEditable(false)
            }else if(response.data.main[0].project_status!='แก้ไข'){
              
              }else if(
                //part1
                response.data.main[0].sdgs
                &&response.data.main[0].response
                &&response.data.main[0]?.oecd_id
                &&response.data.main[0].project_place
                //part2
                &&Array.isArray(response.data.head_researcher)
                //part3
                &&response.data.main[0].resolution
                &&response.data.main[0].objective_list
                &&response.data.main[0].benefit
                &&response.data.main[0].literacy
                &&response.data.main[0].idea
                &&response.data.main[0].solution
                &&response.data.main[0].activity
                //part4
                &&response.data.main[0].output
                &&response.data.main[0].outcome
                &&response.data.main[0].impacts
                //part5
                &&response.data.compensation.length>0
                &&response.data.outcome.length>0
                &&response.data.itemexpense.length>0
            ){
                SetSuccessProgress(100)
            }
            setType(response.data.main[0].project_type)
            if(response.data.main[0].response){
                let tmpres = JSON.parse(response.data.main[0].response)
                let text = tmpres.selectedchoice
                .map((choice:any) =>
                  choice === "ตอบสนองต่อยุทธศาสตร์ชาติ"
                    ? tmpres.country
                      ? `${choice}(${tmpres.country}) `
                      : choice
                    : choice === "ตอบสนองต่อยุทธศาสตร์ของมหาวิทยาลัยวงษ์ชวลิตกุล"
                    ? tmpres.uni
                      ? `${choice}(${tmpres.uni}) `
                      : choice
                      : choice === "ตอบสนองต่อความต้องการของชุมชนพื้นที่"
                    ? tmpres.city
                      ? `${choice}(${tmpres.city}) `
                      : choice
                      : choice === "ตอบสนองต่อการเรียนรู้ตลอดชีวิต / สังคมผู้สูงอายุ"
                    ? tmpres.age
                      ? `${choice}(${tmpres.age}) `
                      : choice
                    : choice === "อื่นๆ"
                    ? tmpres.other
                    : choice
                )
                .join(",");
                setResponsibility(text)
                // if(tmpres.selectedchoice.includes("อื่นๆ")){
                //     const text = [...tmpres.selectedchoice.filter((choice: string) => choice !== "อื่นๆ"), tmpres.other].join(',');
                //     setResponsibility(text)
                // }else{
                //     setResponsibility(tmpres.selectedchoice.join(','))
                // }
            }
            if(response.data.main[0].summary_comment){
              setSummaryComment(response.data.main[0].summary_comment)
            }
            //part 1 is filled
            if(response.data.main[0].sdgs&&response.data.main[0].response&&response.data.main[0].oecd_id&&response.data.main[0].project_place){
                percent+=20
                SetSuccessProgress(percent)
                setpart2(true)
                SetSuccessProgress(successprogress+20)
            }
            //part 2 is filled
            setHeadData(response.data.head_researcher[0])
            if(Array.isArray(response.data.head_researcher)&&response.data.head_researcher.length>0){
                setpart3(true) 
                percent+=20
                SetSuccessProgress(percent)
                seteduData(JSON.parse(response.data.head_researcher[0].head_edu))
                setresData(JSON.parse(response.data.head_researcher[0].head_res))
                setPubData(JSON.parse(response.data.head_researcher[0].head_pub))
            }else{
              axios.get(`${process.env.REACT_APP_API}/get-researcher-team/${sessionStorage.getItem('user')}`).then(response => {
                seteduData(response.data.eduResult)
            }).catch(error =>{console.log(error)})
            }

            //part 3 is filled
            if(response.data.main[0].resolution
                &&response.data.main[0].objective_list
                &&response.data.main[0].benefit
                &&response.data.main[0].literacy
                &&response.data.main[0].idea
                &&response.data.main[0].solution
                &&response.data.main[0].activity
            ){
                percent+=20
                setpart4(true)
                SetSuccessProgress(percent)
            }

            //part 4 is filled
            if(response.data.main[0].output&&response.data.main[0].outcome&&response.data.main[0].impacts){
                setpart5(true)
                percent+=20
                SetSuccessProgress(percent)
                setOutput(JSON.parse(response.data.main[0].output))
                setOutcome(JSON.parse(response.data.main[0].outcome))
                setImpacts(JSON.parse(response.data.main[0].impacts))
              }

            
            
            if(response.data.main[0].period){
                const dataperiod = JSON.parse(response.data.main[0].period)
                const datamonth = dataperiod[0].split('-')
                const datamonth2 = dataperiod[1].split('-')
                setselectedmonth(Number(datamonth[1]))
                setEndMonth(Number(datamonth2[1]))
                setselectedyear(Number(datamonth[0]))
            }
            
            if(response.data.subInfo.length>0){
                setJoinParticipant(response.data.subInfo)
                setexistparticipant(true)
            }
            //part5
           
            if(response.data.compensation.length!=0||response.data.outcome.length!=0||response.data.itemexpense.length!=0||response.data.StudentBudget.length!=0){
                setfundpart(true);
                percent+=20
                SetSuccessProgress(percent)
                setCompensationItems(response.data.compensation)
                const totalCompensation = response.data.compensation.reduce((sum: any, item: any) => sum + item.Budget, 0);
                setCompensationSum(totalCompensation)
                const totalMonetryCompensationBudget = response.data.compensation
                    .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setCompensationMonetrySum(totalMonetryCompensationBudget)
                const totalPreparedCompensationBudget = response.data.compensation
                    .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setCompensationPreparedSum(totalPreparedCompensationBudget)
                const totalIndirectCompensationBudget = response.data.compensation
                    .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setCompensationIndirectSum(totalIndirectCompensationBudget)
            
                const totalOutcome = response.data.outcome.reduce((sum: any, item: any) => sum + item.Budget, 0);
                setOutcomeSum(totalOutcome)
                setOutcomeItems(response.data.outcome)
                const totalMonetryOutcomeBudget = response.data.outcome
                .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setOutcomeMonetrySum(totalMonetryOutcomeBudget)
                const totalPreparedOutcomeBudget = response.data.outcome
                .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setOutcomePreparedSum(totalPreparedOutcomeBudget)
                const totalIndirectdOutcomeBudget = response.data.outcome
                .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setOutcomeIndirectSum(totalIndirectdOutcomeBudget)

                const totalItem = response.data.itemexpense.reduce((sum: any, item: any) => sum + item.Budget, 0);
                setItemnSum(totalItem)
                setItemCost(response.data.itemexpense)
                const totalMonetryItemBudget = response.data.itemexpense
                .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setItemMonetrySum(totalMonetryItemBudget)
                const totalPreparedItemeBudget = response.data.itemexpense
                .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setItemPreparedSum(totalPreparedItemeBudget)
                const itemMonetrySum = response.data.itemexpense
                .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setItemIndirectSum(itemMonetrySum)
                
            }
            if(response.data.main[0].Explanation){
              Explanation.setFieldsValue(JSON.parse(response.data.main[0].Explanation))
            }
            
            if(response.data.ToolDraft.length>0){
                setFilename(response.data.ToolDraft[0].fileName)
                setToolDraft(true)
            }
            if(response.data.main[0].project_status!='แก้ไข'){
                console.log('nono')
            }else if(
                //part1
                response.data.main[0].sdgs
                &&response.data.main[0].response
                &&response.data.main[0]?.oecd_id
                &&response.data.main[0].project_place
                //part2
                &&Array.isArray(response.data.head_researcher)
                //part3
                &&response.data.main[0].resolution
                &&response.data.main[0].objective_list
                &&response.data.main[0].benefit
                &&response.data.main[0].literacy
                &&response.data.main[0].idea
                &&response.data.main[0].solution
                &&response.data.main[0].activity
                //part4
                &&response.data.main[0].output
                &&response.data.main[0].outcome
                &&response.data.main[0].impacts
                //part5
                &&response.data.compensation.length>0
                &&response.data.outcome.length>0
                &&response.data.itemexpense.length>0
            ){
                SetSuccessProgress(100)
            }
        }).finally(()=>
          setActive(true)
        )
    }
    

    const handleSetEditor = async () => {
      let tmptext = `
        <h2 class="document-title">
            <strong>ข้อมูลงานวิจัยและนวัตกรรมที่กำลังยื่นของบประมาณ</strong><br>
        </h2>
        <h3 class="document-subtitle">
            <strong><u>ส่วนที่ 1 ข้อมูลงานวิจัย</u></strong><br/>
        </h3>
        <p>
            <strong>ชื่อโครงการ (ไทย) : </strong>${DataFirst[0].project_name_th}
        </p>
        <p>
            <strong>ชื่อโครงการ (อังกฤษ) : </strong>${DataFirst[0].project_name_en}
        </p>
        <p><strong>ประเภททุนของโครงการ:</strong> ${DataFirst[0]?.budget_type} </p>
        <p><strong>ประเภทของงานวิจัย :</strong> ${mapTypetoName(tmpType)} ${tmpType === 7 ? DataFirst[0]?.other_project_type || '' : ''}</p>
        <p><strong>The 17 sustainable development goals (SDGs) ที่มีความสอดคล้องกับงานวิจัย :</strong> ${DataFirst[0]?.sdgs.replace("[", "").replace("]", "")} </p>
        <p><strong>การตอบสนองต่อความต้องการของประเทศและชุมชนของงานวิจัย :</strong> ${responsibility}</p>
        <p>
          <strong>สาขาวิชาที่ทำการวิจัย :</strong> 
          ${DataFirst[0]?.oecd_type} &nbsp;&nbsp; 
          (${DataFirst[0]?.oecd_sub_type} 
          ${DataFirst[0]?.oecd_field ? `&nbsp;&nbsp;(${DataFirst[0]?.oecd_field})` : ''})
        </p>
        <p><strong>สถานที่ทำการทดลอง/เก็บข้อมูล :</strong> </p>
        <p>${DataFirst[0]?.project_place}</p>
        <br/>
        <div class="page-break" style="page-break-after:always;">
            <span style="display:none;">&nbsp;</span>
        </div>
        <h3 class="document-subtitle">
            <strong><u>ส่วนที่ 2 ข้อมูลบุคลากรที่เกี่ยวข้องกับงานวิจัย</u></strong><br/>
        </h3>
        
      `;
      if(isNull(DataFirst[0]?.pro_name)){
        tmptext+=`<p className="leading-relaxed text-s" style={{color:'Grey'}}><i>โครงการนี้ไม่มีที่ปรึกษา</i></p>`
      }else{
        tmptext+=`
                <p><strong> ที่ปรึกษา </strong></p>
                <p><strong> ชื่อ-นามสกุล :</strong> ${DataFirst[0]?.pro_name} </p>
                <p><strong> ตำแหน่งทางวิชาการ :</strong> ${DataFirst[0]?.pro_position}</p>
                <p><strong> หน่วยงานที่สังกัด :</strong> ${DataFirst[0]?.pro_wp}</p>
                <p><strong> ประสบการณ์ในการวิจัย (หรือความชำนาญในสายงาน) :</strong> ${DataFirst[0]?.pro_exp}</p>
                `
      }

      tmptext+=`
      <br/>
      <p><strong><u>ข้อมูลหัวหน้าโครงการวิจัย</strong></u></p>
      <p><strong>ชื่อภาษาไทย :</strong> ${User?.Per_PrefixTH}${User?.Per_FNameTH} ${User?.Per_LNameTH}</p>
      <p><strong>ชื่อภาษาอังกฤษ :</strong> ${User?.Per_PrefixEN}${User?.Per_FNameEN} ${User?.Per_LNameEN}</p>
      <p> <strong>สถานที่ทำงาน :</strong> ${HeadData?.head_wp}</p>
      <p> <strong>สัดส่วนการเข้าร่วมโครงการวิจัย :</strong> ${HeadData?.join_per} เปอร์เซ็นต์จากทั้งหมด</p>
      <br/>
      <p><strong>วุฒิการศึกษา</strong></p>
        <figure class="table" style="width:79.3%;">
          <table style="border-collapse: collapse; border-style: solid; width: 100%;">
              <tbody>
                  <tr>
                      <td style="border-bottom-style:solid;
                      border-color:windowtext;
                      border-left-style:solid;
                      border-right-style:solid;
                      border-top-style:solid;
                      border-width:1.0pt;padding:0cm 5.4pt;
                      vertical-align:top;">
                          ระดับปริญญา
                      </td>
                      <td style="border-bottom-style:solid;
                      border-color:windowtext;
                      border-left-style:solid;
                      border-right-style:solid;
                      border-top-style:solid;
                      border-width:1.0pt;
                      padding:0cm 5.4pt;
                      vertical-align:top;">
                          วุฒิการศึกษา
                      </td>
                      <td style="border-bottom-style:solid;
                      border-color:windowtext;
                      border-left-style:solid;
                      border-right-style:solid;
                      border-top-style:solid;
                      border-width:1.0pt;
                      padding:0cm 5.4pt;
                      vertical-align:top;">
                          สถาบันการศึกษา
                      </td>
                      <td style="border-bottom-style:solid;
                      border-color:windowtext;
                      border-left-style:solid;
                      border-right-style:solid;
                      border-top-style:solid;
                      border-width:1.0pt;
                      padding:0cm 5.4pt;
                      vertical-align:top;">
                          ปีที่สำเร็จการศึกษา
                      </td>
                      <td style="border-bottom-style:solid;
                                border-color:windowtext;
                                border-left-style:solid;
                                border-right-style:solid;
                                border-top-style:solid;
                                border-width:1.0pt;
                                padding:0cm 5.4pt;
                                vertical-align:top;">
                          ประเทศ
                      </td>
                  </tr>
      `
      for(let i = 0; i < eduData.length;i++){
        tmptext+=`<tr>
                    <td style="border-bottom-style:solid;border-color:windowtext;border-left-style:solid;border-right-style:solid;border-top-style:solid;border-width:1.0pt;padding:0cm 5.4pt;vertical-align:top;">
                        ${eduData[i].edu_level}
                    </td>
                    <td style="border-bottom-style:solid;border-color:windowtext;border-left-style:solid;border-right-style:solid;border-top-style:solid;border-width:1.0pt;padding:0cm 5.4pt;vertical-align:top;">
                        ${eduData[i].edu_qual}
                    </td>
                    <td style="border-bottom-style:solid;border-color:windowtext;border-left-style:solid;border-right-style:solid;border-top-style:solid;border-width:1.0pt;padding:0cm 5.4pt;vertical-align:top;">
                        ${eduData[i].edu_place}
                    </td>
                    <td style="border-bottom-style:solid;border-color:windowtext;border-left-style:solid;border-right-style:solid;border-top-style:solid;border-width:1.0pt;padding:0cm 5.4pt;vertical-align:top;">
                        ${eduData[i].edu_year}
                    </td>
                    <td style="border-bottom-style:solid;border-color:windowtext;border-left-style:solid;border-right-style:solid;border-top-style:solid;border-width:1.0pt;padding:0cm 5.4pt;vertical-align:top;">
                        ${eduData[i].edu_country}
                    </td>
                </tr>`
      }
      tmptext+=`</tbody>
          </table>
      </figure>
      <p><strong>ประสบการณ์ในการวิจัย</strong></p>
      <figure class="table" style="width:79.3%;">
          <table class="ck-table-resized style="width: 100%; border-collapse: collapse; border: 1px solid black;"">
              <colgroup><col style="width:16.74%;"><col style="width:17.01%;"><col style="width:15.67%;"><col style="width:22.98%;"><col style="width:27.6%;"></colgroup>
              <tbody>
                <tr>
                      <td class="style="border: 1px solid black; text-align:center;"">
                        <p style="text-align:center;">
                          ปี พ.ศ.
                        </p>
                      </td>
                      <td class="style="border: 1px solid black; text-align:center;"">
                        <p style="text-align:center;">
                          ชื่อเรื่องวิจัย
                        </p>
                      </td>
                      <td class="style="border: 1px solid black; text-align:center;"">
                        <p style="text-align:center;">
                          สถานะในโครงการ
                        </p>
                      </td>
                      <td class="style="border: 1px solid black; text-align:center;"">
                        <p style="text-align:center;">
                          รายชื่อคณะวิจัย
                        </p>
                      </td>
                  </tr>
      `
      for(let i = 0 ; i<resData.length;i++){
          tmptext+=` <tr>
            <td style="border: 1px solid black; text-align:center;">
                ${resData[i].year}
            </td>
            <td style="border: 1px solid black; text-align:center;">
              ${resData[i].project_name}
            </td>
            <td style="border: 1px solid black; text-align:center;">
              ${resData[i].role}
            </td>
            <td style="border: 1px solid black; text-align:center;">
            `
            if(resData[i].join_project.length==0){
                tmptext+=`ไม่มีผู้ร่วมวิจัย`
            }else{
              for(let j = 0 ; j<resData[i].join_project.length;j++){
                tmptext+=`${resData[i].join_project[j].Per_PrefixTH} ${resData[i].join_project[j].Per_FNameTH} ${resData[i].join_project[j].Per_LNameTH}
                <br/>`
              }
            }
            
            tmptext+=`</td>`

      }
      tmptext+=`</tbody>
          </table>
      </figure>
      <p><strong> การตีพิมพ์เผยแพร่งานวิจัย / บทความทางวิชาการ </strong></p>
      <figure class="table" style="width:79.3%;">
          <table class="ck-table-resized">
              <colgroup><col style="width:16.74%;"><col style="width:17.01%;"><col style="width:15.67%;"><col style="width:22.98%;"><col style="width:27.6%;"></colgroup>
              <tbody>
                <tr>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ปีที่พิมพ์
                          </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ชื่อบทความทางวิชาการ
                          </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ชื่อบทความทางวิชาการภาษาอังกฤษ
                          </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ประเภทสิ่งตีพิมพ์
                          </p>
                      </td>
                  </tr>
      `
      for(let i = 0 ; i < pubData.length ; i++){
        tmptext+=`<tr>
          <td style="border: 1px solid black; text-align:center;">
              ${pubData[i].year}
          </td>
          <td style="border: 1px solid black; text-align:center;">
              ${pubData[i].academic_name}
          </td>
          <td style="border: 1px solid black; text-align:center;">
              ${pubData[i].academic_en_name}
          </td>
          <td style="border: 1px solid black; text-align:center;">
              ${pubData[i].academic_datebase}
          </td>
      </tr>`
      }

      tmptext+=`</tbody>
          </table>
      </figure>
      <br/>
      `
      if(joinParticipant.length!=0){
        tmptext+=`<p><u><strong>ข้อมูลผู้ร่วมวิจัย</strong></u></p>`
        for(let i = 0;i<joinParticipant.length;i++){
          tmptext+=`<p><strong>รหัสผู้ร่วมวิจัย :</strong> ${joinParticipant[i].head_id}</p>
          <p><strong>ชื่อผู้ร่วมวิจัย :</strong> ${joinParticipant[i].head_name_th}</p>
          <p><strong>สถานที่ทำงาน :</strong> ${joinParticipant[i].head_wp}</p>
          <p><strong>สัดส่วนการเข้าร่วมโครงการวิจัย :</strong> ${joinParticipant[i].join_per} เปอร์เซ็นต์จากทั้งหมด</p>
          <br/>
          <p><strong>วุฒิการศึกษา</strong></p>
          <figure class="table" style="width:79.3%;">
            <table class="ck-table-resized">
                
                <tbody>
                 <tr>
                  <td style="border: 1px solid black; padding: 0cm 5.4pt; vertical-align: top; width: 16.74%;">
                    <p style="text-align:center;">ระดับปริญญา</p>
                  </td>
                  <td style="border: 1px solid black; padding: 0cm 5.4pt; vertical-align: top; width: 17.01%;">
                    <p style="text-align:center;">วุฒิการศึกษา</p>
                  </td>
                  <td style="border: 1px solid black; padding: 0cm 5.4pt; vertical-align: top; width: 15.67%;">
                    <p style="text-align:center;">สถาบันการศึกษา</p>
                  </td>
                  <td style="border: 1px solid black; padding: 0cm 5.4pt; vertical-align: top; width: 22.98%;">
                    <p style="text-align:center;">ปีที่สำเร็จการศึกษา</p>
                  </td>
                  <td style="border: 1px solid black; padding: 0cm 5.4pt; vertical-align: top; width: 27.6%;">
                    <p style="text-align:center;">ประเทศ</p>
                  </td>
                </tr>
          `
          let tmped = JSON.parse(joinParticipant[i].head_edu)
          for(let j = 0;j<JSON.parse(joinParticipant[i].head_edu).length;j++){
            tmptext+=` <tr>
                      <td style="border: 1px solid black; text-align:center;">
                          ${tmped[j].edu_level}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                      ${tmped[j].edu_qual}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                      ${tmped[j].edu_place}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                      ${tmped[j].edu_year}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                      ${tmped[j].edu_country}
                      </td>
                  </tr>`
          }
          
          tmptext+=`</tbody>
          </table>
      </figure>
      <p>
          <strong>ประสบการณ์ในการวิจัย</strong>
      </p>
      <figure class="table" style="width:79.3%;">
                <table class="ck-table-resized">
                    <colgroup><col style="width:16.74%;"><col style="width:17.01%;"><col style="width:15.67%;"><col style="width:22.98%;"><col style="width:27.6%;"></colgroup>
                    <tbody>
                      <tr>
                            <td style="border: 1px solid black; text-align:center;">
                              <p style="text-align:center;">
                                ปี พ.ศ.
                              </p>
                                </td>
                            <td style="border: 1px solid black; text-align:center;">
                              <p style="text-align:center;">
                                ชื่อเรื่องวิจัย
                              </p>
                                </td>
                            <td style="border: 1px solid black; text-align:center;">
                              <p style="text-align:center;">
                                สถานะในโครงการ
                              </p>
                                </td>
                            <td style="border: 1px solid black; text-align:center;">
                              <p style="text-align:center;">
                                รายชื่อคณะวิจัย
                              </p>
                            </td>
                        </tr>
      `
      let tmpres = JSON.parse(joinParticipant[i].head_res)
      for(let j = 0;j<JSON.parse(joinParticipant[i].head_res).length;j++ ){
        tmptext+=`
          <tr>
              <td style="border: 1px solid black; text-align:center;">
                  ${tmpres[j].year}
              </td>
              <td style="border: 1px solid black; text-align:center;">
                ${tmpres[j].project_name}
              </td>
              <td style="border: 1px solid black; text-align:center;">
                ${tmpres[j].role}
              </td>
              <td style="border: 1px solid black; text-align:center;">
        `
        if(tmpres[j].join_project.length==0){
          tmptext+=`ไม่มีผู้ร่วมวิจัย`
          
        }else{
          for(let k = 0 ; k<tmpres[j].join_project.length;k++){
            tmptext+=`<p>${tmpres[j].join_project[k].Per_PrefixTH} 
            ${tmpres[j].join_project[k].Per_FNameTH} 
            ${tmpres[j].join_project[k].Per_LNameTH}</p>`
          }
          
        }
        tmptext+=`</td>`
      }

      tmptext+=`</tbody>
          </table>
      </figure>
      <p><strong> การตีพิมพ์เผยแพร่งานวิจัย / บทความทางวิชาการ </strong></p>
      <figure class="table" style="width:79.3%;">
          <table class="ck-table-resized">
              <colgroup><col style="width:16.74%;"><col style="width:17.01%;"><col style="width:15.67%;"><col style="width:22.98%;"><col style="width:27.6%;"></colgroup>
              <tbody>
                <tr>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ปีที่พิมพ์
                        </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ชื่อบทความทางวิชาการ
                        </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ชื่อบทความทางวิชาการภาษาอังกฤษ
                        </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ประเภทสิ่งตีพิมพ์
                        </p>
                      </td>
                  </tr>
      `
      let tmppub = JSON.parse(joinParticipant[i].head_pub)
      for(let j = 0 ; j < JSON.parse(joinParticipant[i].head_pub).length ; j++){
        tmptext+=`<tr>
                      <td style="border: 1px solid black; text-align:center;">
                          ${tmppub[j].year}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                          ${tmppub[j].academic_name}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                          ${tmppub[j].academic_en_name}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                          ${tmppub[j].academic_datebase}
                      </td>
                  </tr>`
      }
      tmptext+=`</tbody>
          </table>
      </figure>`
        }
      }
      tmptext+=`
      <div class="page-break" style="page-break-after:always;">
          <span style="display:none;">&nbsp;</span>
      </div>
      <h3 class="document-subtitle">
        <strong><u>ส่วนที่ 3 รายละเอียดโครงการงานวิจัย</u></strong><br/>
      </h3>
      <p><strong>ความสำคัญ / เหตุผล / ปัญหาที่สำคัญของงานวิจัย / นิยามศัพท์เฉพาะ</strong></p>
      `
      tmptext+=DataFirst?.[0]?.resolution

      tmptext+=`
      <p><strong>วัตถุประสงค์ของงานวิจัย</strong></p>
      `
      tmptext+=DataFirst?.[0]?.objective_list

      tmptext+=`
      <p><strong>ประโยชน์ที่คาดว่าจะได้รับ</strong></p>
      `
      tmptext+=DataFirst?.[0]?.benefit

      tmptext+=`
      <p><strong>การทบทวนวรรณกรรมและผลงานวิจัยที่เกี่ยวข้อง</strong></p>
      `
      tmptext+=DataFirst?.[0]?.literacy

      tmptext+=`
      <p><strong>กรอบแนวคิดในการวิจัย</strong></p>
      `
      tmptext+=DataFirst?.[0]?.idea

      tmptext+=`
      <p><strong>ระเบียบวิธีวิจัย</strong></p>
      `
      tmptext+=DataFirst?.[0]?.solution

      tmptext+=`
      <p><strong>ระยะเวลาทำการวิจัย</strong></p>
      <p class="info-box">${DataFirst?.[0]?.period ? periodToString(DataFirst[0].period) : 'ยังไม่มีการกรอก'}</p>
      `
      const tmp_period = monthcolumn(
        selectedmonth,
        endmonth,
        DataFirst?.[0]?.period ? JSON.parse(DataFirst?.[0]?.period) : []
    ) as ColumnGroup[];
      
      let tmplength = tmp_period[0].children.length+((tmp_period.length-2)*3)+tmp_period[tmp_period.length-1].children.length
      console.log(`sum: `+tmplength+`,tmp_period:`+tmp_period.length)
      if(tmp_period[0].children.length==2){
        tmplength = 2;
      }
      tmptext+=`
      <p><strong>แผนการดำเนินงานตลอดโครงการ</strong></p>
      <figure class="table" style="width:79.3%;">
            <table class="ck-table-resized">
                <colgroup>
                  <col style="width:16.74%;">
                    <col style="width:17.01%;"><col style="width:15.67%;">
                      <col style="width:22.98%;">
                      <col style="width:27.6%;"></colgroup>
                <tbody>
                <tr>
                  <td rowspan="3">
                    <p style="text-align:center;">
                      กิจกรรมในการวิจัย
                    </p>
                  </td>
                  <td colspan="${tmplength}">
                    <p style="text-align:center;">
                      ระยะเวลาที่ทำกิจกรรม
                    </p>
                  </td>
                  <td rowspan="3">
                    <p style="text-align:center;">
                      ร้อยละของกิจกรรมในโครงการ
                    </p>
                  </td>
                </tr>
                <tr>
      `
      
      for (let i = 0; i < tmp_period.length; i++) {
        tmptext += `
        <td colspan="${tmp_period[i].children.length}">
          ${tmp_period[i].title}
        </td>
        `;
    }
      tmptext+=`</tr><tr>`
      for (let i = 0; i < tmp_period.length; i++) {
        for(let j = 0; j < tmp_period[i].children.length;j++){
          console.log(tmp_period[i].children[j])
          tmptext += `
          <td>
            ${tmp_period[i].children[j].title}
          </td>
        `;}
    }
      tmptext+=`</tr>`
    let period = DataFirst?.[0]?.period? JSON.parse(DataFirst?.[0]?.period): [];
    const [startyear, endyear] = [period[0].split('-')[0], period[1].split('-')[0]];
    let data_activity = DataFirst?.[0]?.activity ? JSON.parse(DataFirst[0].activity) : []
    for(let i = 0;i<data_activity.length;i++){
      tmptext+=`
        <tr>
          <td>
            <p>${data_activity[i].ActivityName}</p>
          </td>
      `
      
      console.log(data_activity[i])
      for(let year = parseInt(startyear); year <= parseInt(endyear); year++){
        const isStartYear = year == parseInt(startyear);
        const isEndYear = year == parseInt(endyear);
        const start = isStartYear ? selectedmonth : 1;
        const end = isEndYear ? endmonth : 12;
        for (let month = start; month <= end; month++) {
          let x = isDateSelected(month, year, data_activity[i].Activitydate, period)
          console.log('data : '+x.props.children)
          tmptext+=`
          <td>
            ${x.props.children}
          </td>
        `
        }
       
      }

      tmptext+=`
          <td>
            <p>${data_activity[i].ActivityRatio}</p>
          </td>
      </tr>`
    }

      tmptext+=`
                </tbody>
              </table>
          </figure>
          `
      //ทำต่อ
      if(JSON.parse(DataFirst?.[0]?.needed_item).length!=0||JSON.parse(DataFirst?.[0]?.possesed_item).length!=0)
      { 
        tmptext+=`<p>อุปกรณ์การวิจัย</p>`
        if(JSON.parse(DataFirst?.[0]?.needed_item).length!=0){
          tmptext+=`
          <p>อุปกรณ์การวิจัยที่มีอยู่แล้ว</p>
          <figure class="table" style="width:79.3%;">
            <table class="ck-table-resized">
                <colgroup><col style="width:16.74%;"><col style="width:17.01%;"><col style="width:15.67%;"><col style="width:22.98%;"><col style="width:27.6%;"></colgroup>
                <tbody>
                  <tr>
                    <td style="border: 1px solid black; text-align:center;">
                      <p style="text-align:center;">
                        อันดับที่
                      </p>
                    </td>
                    <td style="border: 1px solid black; text-align:center;">
                      <p style="text-align:center;">
                        อุปกรณ์ที่ใช้
                      </p>
                    </td>
                  </tr>
                    `
          const tmp_needed_item = JSON.parse(DataFirst?.[0]?.needed_item)
          for(let i =0;i<tmp_needed_item.length;i++){
            tmptext+=`<tr>
                        <td style="border: 1px solid black; text-align:center;">
                          <p style="text-align:center;">
                            ${tmp_needed_item[i].index+1}
                          </p>
                        </td>
                        <td style="border: 1px solid black; text-align:center;">
                          <p style="text-align:center;">
                            ${tmp_needed_item[i].item}
                          </p>
                        </td>
                      </tr>
            `
          }
          tmptext+=`
                </tbody>
              </table>
          </figure>
          `
        }
        if(JSON.parse(DataFirst?.[0]?.possesed_item).length!=0){
          tmptext+=`<figure class="table" style="width:79.3%;">
          <table class="ck-table-resized">
              <colgroup><col style="width:16.74%;"><col style="width:17.01%;"><col style="width:15.67%;"><col style="width:22.98%;"><col style="width:27.6%;"></colgroup>
              <tbody>
                <tr>`
          const tmp_possesed_item = JSON.parse(DataFirst?.[0]?.possesed_item)
          for(let i =0;i<JSON.parse(DataFirst?.[0]?.possesed_item).length;i++){
            tmptext+=`
              <tr>
                        <td style="border: 1px solid black; text-align:center;">
                          ${tmp_possesed_item[i].index+1}
                        </td>
                        <td style="border: 1px solid black; text-align:center;">
                          ${tmp_possesed_item[i].item}
                        </td>
                      </tr>

            `
          }
          tmptext+=`
          </tbody>
        </table>
    </figure>
    `
        }
      }

      tmptext+=`
      <div class="page-break" style="page-break-after:always;">
        <span style="display:none;">&nbsp;</span>
    </div>
      <h3 class="document-subtitle">
        <strong><u>ส่วนที่ 4 ผลลัพธ์และผลกระทบ</u></strong><br/>
      </h3>
      <p><strong>ผลผลิตที่คาดว่าจะได้รับ</strong></p>
      <figure class="table" style="width:79.3%;">
          <table class="ck-table-resized">
              <colgroup><col style="width:16.74%;"><col style="width:17.01%;"><col style="width:15.67%;"><col style="width:22.98%;"><col style="width:27.6%;"></colgroup>
              <tbody>
                <tr>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ผลผลิต
                        </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ประเภทผลผลิต
                        </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          รายละเอียดของผลผลิต
                        </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          จำนวนนำส่ง
                        </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          หน่วยนับ
                        </p>
                      </td>
                  </tr>
      `

      for(let i = 0; i < Output.length;i++){
        tmptext+=`<tr>
                      <td style="border: 1px solid black; text-align:center;">
                          ${Output[i].Output_name}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                          ${Output[i].Output_type}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                          ${Output[i].Output_description}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                          ${Output[i].Output_amount}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                          ${Output[i].Output_unit}
                      </td>
                  </tr>`
      }
      tmptext+=`</tbody>
          </table>
      </figure>
      <br/>
      
      <p><strong>ผลลัพธ์ที่คาดว่าจะเกิดขึ้น</strong></p>
      <figure class="table" style="width:79.3%;">
          <table class="ck-table-resized">
              <colgroup><col style="width:16.74%;"><col style="width:17.01%;"><col style="width:15.67%;"><col style="width:22.98%;"><col style="width:27.6%;"></colgroup>
              <tbody>
                <tr>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ผลลัพธ์ที่คาดว่าจะได้รับ
                        </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          จำนวน
                          </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          หน่วยนับ
                          </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          รายละเอียดผลลัพธ์
                          </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ผู้ใช้ประโยชน์(Users)/ผู้ได้รับผลประโยชน์(Beneficiaries)
                          </p>
                      </td>
                  </tr>
      `
      for(let i = 0; i < Outcome.length;i++){
        tmptext+=`
          <tr>
            <td style="border: 1px solid black; text-align:center;">
              ${Outcome[i].Outcome_name}
            </td>
            <td style="border: 1px solid black; text-align:center;">
              ${Outcome[i].Outcome_amount}
            </td>
            <td style="border: 1px solid black; text-align:center;">
              ${Outcome[i].Outcome_unit}
            </td>
            <td style="border: 1px solid black; text-align:center;">
              ${Outcome[i].Outcome_description}
            </td>
            <td style="border: 1px solid black; text-align:center;">
              ${Outcome[i].Outcome_Benefitor}
            </td>
            </tr>
        `
      }
      tmptext+=`</tbody>
          </table>
      </figure>
      <br/>
      `
      //แก้ไข
      if(Impacts?.academic_impacts ||
        Impacts?.social_impacts || 
        Impacts?.public_impacts ||  
        Impacts?.city_impacts || 
        Impacts?.environment_impacts || 
        Impacts?.policy_impacts || 
        Impacts?.economy_impacts){
          tmptext+=`
            <p><strong>ผลกระทบ</strong></p>
            `
        if(Impacts?.academic_impacts){
          tmptext+=`
            <p>ผลกระทบด้านวิชาการ : ${Impacts.academic_impacts}</p>
            `
        }
        if(Impacts?.social_impacts){
          tmptext+=`
          <p>ผลกระทบด้านสังคม : ${Impacts.social_impacts}</p>
          `
        }
        if(Impacts?.public_impacts){
          tmptext+=`
          <p>ผลกระทบด้านสาธารณะ : ${Impacts.public_impacts}</p>
          `
        }
        if(Impacts?.city_impacts){
          tmptext+=`
          <p>ผลกระทบด้านชุมชนและพื้นที่ : ${Impacts.city_impacts}</p>
          `
        }
        if(Impacts?.environment_impacts){
          tmptext+=`
          <p>ผลกระทบด้านสิ่งแวดล้อม : ${Impacts.environment_impacts}</p>
          `
        }
        if(Impacts?.policy_impacts){
          tmptext+=`
          <p>ผลกระทบด้านนโยบาย : ${Impacts.policy_impacts}</p>
          `
        }
        if(Impacts?.economy_impacts){
          tmptext+=`
          <p>ผลกระทบด้านเศรษฐกิจ : ${Impacts.economy_impacts}</p>
          `
        }
        
      }

      tmptext+=`
      <div class="page-break" style="page-break-after:always;">
          <span style="display:none;">&nbsp;</span>
      </div>
      <h3 class="document-subtitle">
        <strong><u>ส่วนที่ 5 งบประมาณและค่าใช้จ่าย</u></strong><br/>
      </h3>
      <p><strong>งบประมาณ</strong></p>
      
      `
      if(DataFirst[0]?.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'){
         tmptext+=`<p class="info-box><strong>โครงการนี้มีทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษาจำนวน</strong> 10,000 <strong>บาทถ้วน</strong></p>`
      }else{
        tmptext+=`
        <figure class="table" style="width:79.3%;">
          <table class="ck-table-resized">
              <colgroup><col style="width:16.74%;"><col style="width:17.01%;"><col style="width:15.67%;"><col style="width:22.98%;"><col style="width:27.6%;"></colgroup>
              <tbody>
                <tr>
                  <td rowspan="2">
                    <p style="text-align:center;">
                      ลำดับที่
                    </p>
                  </td>
                  <td rowspan="2">
                  <p style="text-align:center;">
                      รายละเอียดประมาณการค่าใช้จ่าย
                      </p>
                  </td>
                  <td colspan="3">
                  <p style="text-align:center;">
                      งบประมาณ
                      </p>
                  </td>
                  <td  rowspan="2">
                  <p style="text-align:center;">
                      รวม
                      </p>
                  </td>
                  <td  rowspan="2">
                  <p style="text-align:center;">
                      หมายเหตุ
                      </p>
                  </td>
                </tr>
                  <tr>
                      <td >
                      <p style="text-align:center;">
                          ตัวเงิน(เบิกจ่าย)</p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                      <p style="text-align:center;">
                          ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้</p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                      <p style="text-align:center;">
                          ไม่เป็นตัวเงิน(งบอ้อม)</p>
                      </td>
                  </tr>`

                  for(let i = 0;i<BudgetTypeCol.length;i++){
                    tmptext+=`
                      <tr>
                        <td style="border: 1px solid black; text-align:center;">
                          <p style="text-align:center;">
                            ${BudgetTypeCol[i].id}</p>
                        </td>
                        <td style="border: 1px solid black; text-align:center;">
                          ${BudgetTypeCol[i].detail}
                        </td>
                        
                        <td style="border: 1px solid black; text-align:center;">
                          ${formatNumber(BudgetTypeCol[i].MonetrySum)}
                        </td>
                        <td style="border: 1px solid black; text-align:center;">
                          ${formatNumber(BudgetTypeCol[i].PreparedSum)}
                        </td>
                        <td style="border: 1px solid black; text-align:center;">
                          ${formatNumber(BudgetTypeCol[i].IndirectSum)}
                        </td>
                        <td style="border: 1px solid black; text-align:center;">
                          ${formatNumber(BudgetTypeCol[i].sum)}
                        </td>
                        <td style="border: 1px solid black; text-align:center;">
                          
                        </td>
                      </tr>
                    `
                    if (BudgetTypeCol[i].category === 'compensation') {
                      for (let j = 0; j < compensationItems.length; j++) {
                        const { BudgetType, Budget, BudgetDetail, budgetid, note } = compensationItems[j];
                        tmptext += `
                          <tr>
                            <td style="border: 1px solid black; text-align:center;">${BudgetTypeCol[i].id}.${Number(budgetid) + 1}</td>
                            <td style="border: 1px solid black; text-align:center;">${BudgetDetail}</td>
                        `;
                    
                        // Budget allocation logic
                        let columns = { col1: 0, col2: 0, col3: 0, col4: 0 };
                        if (BudgetType === 'ตัวเงิน(เบิกจ่าย)') {
                          columns.col1 = Budget;
                          columns.col4 = Budget;
                        } else if (BudgetType === 'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้') {
                          columns.col2 = Budget;
                          columns.col4 = Budget;
                        } else if (BudgetType === 'ไม่เป็นตัวเงิน(งบอ้อม)') { // Adjust for additional types
                          columns.col3 = Budget;
                          columns.col4 = Budget;
                        }
                    
                        tmptext += `
                            <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col1)}</td>
                            <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col2)}</td>
                            <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col3)}</td>
                            <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col4)}</td>
                            <td style="border: 1px solid black; text-align:center;"><p>${note}</p></td>
                          </tr>
                        `;
                      }
                      
                    } 
                    else if (BudgetTypeCol[i].category === 'outcome') {
                      for (let j = 0; j < OutcomeItems.length; j++) {
                        const { BudgetType, Budget, BudgetDetail, budgetid, note } = OutcomeItems[j];
                        tmptext += `
                          <tr>
                            <td style="border: 1px solid black; text-align:center;">${BudgetTypeCol[i].id}.${Number(budgetid) + 1}</td>
                            <td style="border: 1px solid black; text-align:center;">${BudgetDetail}</td>
                        `;
                    
                        // Budget allocation logic
                        let columns = { col1: 0, col2: 0, col3: 0, col4: 0 };
                        if (BudgetType === 'ตัวเงิน(เบิกจ่าย)') {
                          columns.col1 = Budget;
                          columns.col4 = Budget;
                        } else if (BudgetType === 'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้') {
                          columns.col2 = Budget;
                          columns.col4 = Budget;
                        } else if (BudgetType === 'ไม่เป็นตัวเงิน(งบอ้อม)') { // Adjust for additional types
                          columns.col3 = Budget;
                          columns.col4 = Budget;
                        }
                    
                        tmptext += `
                            <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col1)}</td>
                            <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col2)}</td>
                            <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col3)}</td>
                            <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col4)}</td>
                            <td style="border: 1px solid black; text-align:center;"><p>${note}</p></td>
                          </tr>
                        `;
                      }
                    }
                    
                    else if (BudgetTypeCol[i].category === 'itemexpense') {
                      for (let j = 0; j < ItemCost.length; j++) {
                        const { BudgetType, Budget, BudgetDetail, budgetid, note } = ItemCost[j];
                        tmptext += `
                          <tr>
                            <td style="border: 1px solid black; text-align:center;">${BudgetTypeCol[i].id}.${Number(budgetid) + 1}</td>
                            <td style="border: 1px solid black; text-align:center;">${BudgetDetail}</td>
                        `;
                    
                        // Budget allocation logic
                        let columns = { col1: 0, col2: 0, col3: 0, col4: 0 };
                        if (BudgetType === 'ตัวเงิน(เบิกจ่าย)') {
                          columns.col1 = Budget;
                          columns.col4 = Budget;
                        } else if (BudgetType === 'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้') {
                          columns.col2 = Budget;
                          columns.col4 = Budget;
                        } else if (BudgetType === 'ไม่เป็นตัวเงิน(งบอ้อม)') { // Adjust for additional types
                          columns.col3 = Budget;
                          columns.col4 = Budget;
                        }
                    
                        tmptext += `
                            <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col1)}</td>
                            <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col2)}</td>
                            <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col3)}</td>
                            <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col4)}</td>
                            <td style="border: 1px solid black; text-align:center;"><p>${note}</p></td>
                          </tr>
                        `;
                      }
                      
                      // dataSource = ItemCost;
                    }
                  }
                  tmptext+=`</tbody>
                  </table>
              </figure>
              <br/>`
      }
      

      tmptext+=`
      <p><strong>บรรณานุกรม</strong></p>`
      tmptext+=DataFirst?.[0]?.reference

      setExportData(tmptext);
      setPreviewLoading(false);
      setPreview(true);
  
      
    };

    
    useEffect(()=>{
        getData();
        getUserData();
        fetchFiles();
    },[]);
    return(
      <>
        {(isActive&&DataFirst)
        &&<div style={{
            padding:15
          }}>
            <div style={{ padding: '20px' }}>
            
            </div>
            <div
                id="part-1">
            <h1 className="text-3xl font-semibold leading-relaxed">ข้อมูลงานวิจัยและนวัตกรรมที่กำลังยื่นของบประมาณ </h1>
            <br/>
            <hr/>
            <br/>
            {DataFirst[0].project_status=='แก้ไข'&& <><p className='font-semibold'><u>อัตราการกรอกข้อมูลงานวิจัย</u></p>
            <br/>
            
            {/* <Progress percent={10} steps={5} style={{ width: '100%' }}/>
            <Progress percent={30} /> */}
            <Row>
                <Col span={5}>
                <Progress type="circle" percent={successprogress} />
                </Col>
                <Col span={200} style={{ alignContent: 'center' }}>
                {successprogress<100 && <p>ขณะนี้โครงการของท่านมีการกรอกข้อมูลไปแล้ว {successprogress} เปอร์เซ็นต์จากทั้งหมด</p> || <p>ขณะนี้โครงการของท่านมีการกรอกข้อมูลครบถ้วนแล้วจากทั้งหมด</p>}
                <br/>
                <Progress percent={successprogress} style={{width:'60vh'}}/> 
                </Col>
            </Row>
            <br/>
            {(tmpeduData.length==0||checkResdata||checkPubData)&&<Card style={{backgroundColor:'#F4EBDD'}}>
              <Flex><p><u>คำเตือน</u></p> &nbsp; <p> ระบบได้ตรวจสอบพบว่าท่านยังขาดข้อมูลประวัติในระบบ MIS กรุณาเพิ่ม </p><Button type='link'><u><a href="https://i.vu.ac.th/research/" target="_blank">ที่นี่</a></u></Button><p> ข้อมูลก่อนกรอกฟอร์มนี้</p> </Flex>
              {tmpeduData.length==0&&<Card style={{backgroundColor:'#F54841'}}>
                <p style={{color:'white'}}>ข้อมูลที่ท่านต้องเพิ่มในระบบ </p>
                <p style={{color:'white',marginLeft:20}}>- ข้อมูลวุฒิการศึกษา</p>
              </Card>}
              <br/>
              {(checkResdata||checkPubData)&&<Card style={{backgroundColor:'#F5E898'}}>
              <p>ข้อมูลที่ท่านไม่มีในระบบ (หากท่านไม่เคยมีงานวิจัยหรืองานตีพิมพ์มาก่อน ท่านไม่ต้องสนใจข้อความนี้ )</p>
              {checkResdata&&<p style={{marginLeft:20}}>- ประวัติข้อมูลงานวิจัย</p>}
              {checkPubData&&<p style={{marginLeft:20}}>- ประวัติข้อมูลงานวิจัยตีพิมพ์</p>}
              </Card>}
            </Card>}
            <br/>
            {(!part2||!part3||!part4||!part5||!fundpart)&&<><Card><p>คำเตือน</p>
            <p>ทางระบบได้ตรวจพบว่าท่านยังกรอกข้อมูลในระบบไม่ครบถ้วน กรุณากรอกข้อมูลในส่วนต่อไปนี้</p>
              <br/>
              <Card style={{backgroundColor:'#F54841'}}>
                <p className='font-semibold' style={{color:'white'}}><u>ข้อมูลส่วนที่ยังไม่ถูกกรอก</u></p>
                {!part2&&<p style={{marginLeft:20,color:'white'}}>- ส่วนที่ 1 ข้อมูลงานวิจัย</p>}
                {!part3&&<p style={{marginLeft:20,color:'white'}}>- ส่วนที่ 2 ข้อมูลบุคลากรที่เกี่ยวข้องกับงานวิจัย</p>}
                {!part4&&<p style={{marginLeft:20,color:'white'}}>- ส่วนที่ 3 รายละเอียดโครงการงานวิจัย</p>}
                {!part5&&<p style={{marginLeft:20,color:'white'}}>- ส่วนที่ 4 ผลลัพธ์และผลกระทบ</p>}
                {!fundpart&&<p style={{marginLeft:20,color:'white'}}>- ส่วนที่ 5 งบประมาณและค่าใช้จ่าย</p>}
                
              </Card>
              </Card>
            </>}
            <br/>
            {joinper!=100&&<Card style={{backgroundColor:'#F54841'}}>
              <Flex><p className='font-semibold' style={{color:'white'}}><u>คำเตือน</u></p> &nbsp; <p></p>
              <p style={{color:'white'}}>ขณะนี้มีสัดส่วนการเข้าร่วมโครงการวิจัยทั้งหมด {joinper} เปอร์เซ็น</p>
              </Flex>
              <p style={{color:'white'}}>ท่านจะไม่สามารถยื่นเสนอโครงการวิจัยหากสัดส่วนการเข้าร่วมโครงการวิจัยของท่านไม่ครบ 100 เปอร์เซ็นต์</p>
              <p style={{color:'white'}}>กรุณาแก้ไขข้อมูลในส่วนที่สองเพื่อให้สามารถยื่นโครงการวิจัยได้</p>
            </Card>
            }</>||<><Card>
              <p className="font-semibold">สถานะของโครงการ : </p>
              {DataFirst[0].project_status=='อนุมัติ'&&<p style={{marginLeft:20, color: '#33b249'}}>{DataFirst[0].project_status}</p>||
              DataFirst[0].project_status=='ไม่อนุมัติ'&&<p style={{marginLeft:20, color: 'red'}}>{DataFirst[0].project_status}</p>||
              (DataFirst[0].project_status=='แก้ไขตามความเห็นของกรรมการ'||
                DataFirst[0].project_status=='สั่งแก้ไขตามความเห็นของกรรมการ'||
                DataFirst[0].project_status=='สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย'||
                DataFirst[0].project_status=='สั่งแก้ไขจากผู้บังคับบัญชาเบื้องต้น'
              )&&<p style={{marginLeft:20, color: '#DAA520'}}>{DataFirst[0].project_status}</p>||
              <p style={{marginLeft:20}}>{DataFirst[0].project_status}</p>
              }
              <p></p>
              {(DataFirst[0].project_status=='สั่งแก้ไขจากผู้บังคับบัญชาเบื้องต้น'&&headComment)&&<>
                <Card><p className='font-semibold'>ข้อความจาก ผู้บังคับบัญชาเบื้องต้น</p>
                <ROCKEditors
                  myRef={headCommentRef}
                  htmlBox={headCommenttext? headCommenttext : "ไม่มีเหตุผลประกอบ"}
                  toolstate={false}
                  />
                    <p>ลงข้อความเมื่อ {moment(headCommentdate).utc().format('DD/MM/YYYY HH:mm:ss')}</p>
                    </Card></>}
              {(DataFirst[0].project_status=='สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย'&&staffComment)&&<>
                <Card><p className='font-semibold'>ข้อความจาก เจ้าหน้าที่</p>
                        <JoditReact
                          value={StaffCommenttext ? StaffCommenttext : "ไม่มีเหตุผลประกอบ"} 
                          config={config}/>
                          <p >ลงข้อความเมื่อ {moment(StaffCommentDate).utc().format('DD/MM/YYYY HH:mm:ss')}</p>
              </Card></>}
              {(DataFirst[0].project_status=='แก้ไขตามความเห็นของกรรมการ')&&<>
              {showSumedit && 
              <Card>
                <p className="font-semibold">ความเห็นของคณะกรรมการต่อโครงการ</p>
                        <Table
                        columns={[{
                          title:'ข้อ',
                          dataIndex:'index',
                          render: (_: any, __: any, rowIndex: number) => (
                            <>{rowIndex + 1}</> // Add 1 to start the index from 1 instead of 0
                          )
                        },{
                          title:'หัวข้อ',
                          dataIndex:'topic'
                        },
                        {
                          title: "ข้อเสนอแนะ",
                          dataIndex: "summary",
                          render: (text: string) => (
                            <span>
                              {text.split("\n").map((line, index) => (
                                <React.Fragment key={index}>
                                  {line}
                                  <br />
                                </React.Fragment>
                              ))}
                            </span>
                          ),
                        },
                      ]}
                        pagination={false}
                        dataSource={JSON.parse(SummaryComment)}
                        />
                      </Card>
                    }</>}
                    
              </Card></>}
            
            <br/><br/>
            <h2 className="text-2xl font-bold leading-relaxed"  style={{display: "flex"}} > <FaPenNib /> ส่วนที่ 1 ข้อมูลงานวิจัย 
            {editable&&<a href={`/VRIIS/Budget_req_About/${ project_id }`}><Button>เพิ่ม/แก้ไขข้อมูล</Button></a>||<Button disabled>เพิ่ม/แก้ไขข้อมูล</Button>}</h2>
            <br/>
            <hr/>
            <br/>
            <Card>
            <Row>
                <Col span={12}>
                    <p className="leading-relaxed font-semibold" >ชื่อโครงการ (ไทย) : </p>
                    <p style={{marginLeft:20}}>{DataFirst[0]?.project_name_th}</p>
                    
                </Col >
                <Col span={12}>
                    <p className="leading-relaxed font-semibold" >ชื่อโครงการ (อังกฤษ) : </p>
                    <p style={{marginLeft:20}}>{DataFirst[0]?.project_name_en}</p>
                </Col>
            </Row>
            <Flex>
            <p className="leading-relaxed font-semibold">ประเภททุนของโครงการ:</p> &nbsp; <p>{DataFirst[0]?.budget_type} </p></Flex>
            <p className="leading-relaxed font-semibold" >ประเภทของงานวิจัย :  </p>
            <p style={{marginLeft:20}}>{mapTypetoName(tmpType)} {tmpType === 7 ? <>: {DataFirst[0]?.other_project_type}</> || '' : ''}</p>
            {isNull(DataFirst[0]?.sdgs) && <>
            <p className="leading-relaxed font-semibold">The 17 sustainable development goals (SDGs) ที่มีความสอดคล้องกับงานวิจัย : </p>
            <p className="leading-relaxed" style={{marginLeft:20,color:'red'}}>**--ยังไม่มีการกรอก--**</p>
            
            </>|| 
            <><p className="leading-relaxed font-semibold">The 17 sustainable development goals (SDGs) ที่มีความสอดคล้องกับงานวิจัย : </p>
            <p className="leading-relaxed" style={{marginLeft:20}}> {DataFirst[0]?.sdgs.replace("[","").replace("]","")} </p></>
            }
            {isNull(DataFirst[0]?.response) && <>
                <p className="leading-relaxed font-semibold">การตอบสนองต่อความต้องการของประเทศและชุมชนของงานวิจัย : </p>
                <p className="leading-relaxed" style={{marginLeft:20,color:'red'}}>**--ยังไม่มีการกรอก--**</p></>|| 
            <><p className="leading-relaxed font-semibold">การตอบสนองต่อความต้องการของประเทศและชุมชนของงานวิจัย :    </p>
            <p style={{marginLeft:20}}>{responsibility}</p></>
            }
            {isNull(DataFirst[0]?.oecd_id) && <>
                <p className="leading-relaxed font-semibold">สาขาวิชาที่ทำการวิจัย :  </p>
                <p>--ยังไม่มีการกรอก--</p></>|| 
            <><p className="leading-relaxed font-semibold">สาขาวิชาที่ทำการวิจัย :</p> 
            <p style={{marginLeft:20}}>{DataFirst[0]?.oecd_type} &nbsp;&nbsp; ({DataFirst[0]?.oecd_sub_type} &nbsp;&nbsp;{DataFirst[0]?.oecd_field && <>({DataFirst[0]?.oecd_field})</>})</p></>
            }
            
            {!isNull(DataFirst[0]?.project_place) && <>
                <p className="leading-relaxed font-semibold">สถานที่ทำการทดลอง/เก็บข้อมูล : </p>
                <p style={{marginLeft:20}}>{DataFirst[0]?.project_place}</p>
            </>
            }
            </Card>
            </div>
            
            <div
                id="part-2">
            <br/>
            <br/>
            <br/>
            
            <h2 className="text-2xl font-bold leading-relaxed">ส่วนที่ 2 ข้อมูลบุคลากรที่เกี่ยวข้องกับงานวิจัย 
                {(editable)&&
                <a href={`/VRIIS/BudgetReqResearcher/${ project_id }`}>
                    <Button>เพิ่ม/แก้ไขข้อมูล</Button></a>
                    ||<Button disabled>เพิ่ม/แก้ไขข้อมูล</Button>}</h2>
            <br/>
            <hr/>
            <br/>
            
            {isNull(DataFirst[0]?.pro_name) && 
                <>
                <p className="leading-relaxed text-s" style={{color:'Grey'}}><i>โครงการของท่านไม่มีที่ปรึกษา</i></p>
                </>
                ||
                <><Card>
                <p className="leading-relaxed font-semibold"> ที่ปรึกษา : </p>
                <Flex>
                <p className="leading-relaxed font-semibold" style={{marginLeft:30}}> ชื่อ-นามสกุล : 
                  </p>&nbsp;<p className='font-normal'>{DataFirst[0]?.pro_name} </p></Flex>
                <Flex><p className="leading-relaxed font-semibold" style={{marginLeft:30}}> ตำแหน่งทางวิชาการ : 
                </p>&nbsp; <p className='font-normal'>{DataFirst[0]?.pro_position}</p></Flex>
                <Flex><p className="leading-relaxed font-semibold" style={{marginLeft:30}}> หน่วยงานที่สังกัด : 
                  </p>&nbsp;<p className='font-normal'>{DataFirst[0]?.pro_wp}</p></Flex>
                <Flex><p className="leading-relaxed font-semibold" style={{marginLeft:30}}> ประสบการณ์ในการวิจัย (หรือความชำนาญในสายงาน) : 
                  </p>&nbsp;<p className='font-normal'>{DataFirst[0]?.pro_exp}</p></Flex>
                </Card>
                </>
            }
            <br/>
            {DataFirst[0]?.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'&&<h3 className="text-l font-semibold" style={{marginBottom:10}}><u>ข้อมูลอาจารย์ที่ปรึกษาโครงการ</u></h3>||<h3 className="text-l font-semibold" style={{marginBottom:10}}><u>ข้อมูลหัวหน้าโครงการวิจัย</u></h3>}
            
            <Flex><p className="leading-relaxed font-semibold">ชื่อภาษาไทย :</p>&nbsp;<p> {User?.Per_PrefixTH} {User?.Per_FNameTH} {User?.Per_LNameTH}</p></Flex>
            <Flex><p className="leading-relaxed font-semibold">ชื่อภาษาอังกฤษ :</p>&nbsp;<p> {User?.Per_PrefixEN} {User?.Per_FNameEN} {User?.Per_LNameEN}</p></Flex>
            {HeadData?.head_email&&<Flex><p className="leading-relaxed font-semibold"> email :</p>&nbsp;<p> {HeadData?.head_email}</p></Flex>}
            {HeadData?.head_wp&&<Flex><p className="leading-relaxed font-semibold"> สถานที่ทำงาน :</p>&nbsp;<p> {HeadData?.head_wp}</p></Flex>}
            {(HeadData?.join_per&&DataFirst[0]?.budget_type!='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา')&&<Flex><p className="leading-relaxed font-semibold"> สัดส่วนการเข้าร่วมโครงการวิจัย :</p>&nbsp;<p> {HeadData?.join_per} เปอร์เซ็นต์จากทั้งหมด</p></Flex>}
            <br/>
            <p className="leading-relaxed font-semibold text-l" style={{marginBottom:10}}> <u>วุฒิการศึกษา</u> </p>
            <Table columns={educolumn}
            locale={{
                emptyText: (
                  <Empty description="ยังไม่มีการกรอกข้อมูลในส่วนที่ 2" /> // Default image with custom text
                ),
              }}
             dataSource={eduData}/>
            
            <br/>
            <p className="leading-relaxed font-semibold" style={{marginBottom:10}}><u>ประสบการณ์ในการวิจัย</u></p>
            <Table columns={headexcolumns}
            locale={{
                emptyText: (
                  <Empty description="ยังไม่มีการกรอกข้อมูลในส่วนที่ 2" /> // Default image with custom text
                ),
              }}
            dataSource={resData}/>
            <br/>
            <p className="leading-relaxed font-semibold" style={{marginBottom:10}}><u> การตีพิมพ์เผยแพร่งานวิจัย / บทความทางวิชาการ </u></p>
            <Table columns={academicHis} 
            locale={{
                emptyText: (
                  <Empty description="ยังไม่มีการกรอกข้อมูลในส่วนที่ 2" /> // Default image with custom text
                ),
              }}
            dataSource={pubData}/>
            <br/>
            {DataFirst[0]?.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'&&<>
              <p className="text-2xl font-bold leading-relaxed">เอกสารแบบฟอร์มแบ่งสัดส่วนงานของผู้ร่วมทำงานวิจัยเชิงนวัตกรรม สำหรับนักศึกษา</p>
              <List
                    bordered
                    dataSource={Studentfile}
                    renderItem={(file) => (
                        <List.Item
                    actions={[
                        <>
                        <Button type='link' onClick={() => DownloadHandle(file.uid)}>Download</Button>
                        </>
                    ]}
                    >
                    <Button type='link' 
                    onClick={() => handlePreview(file)}>{file.name}</Button>
                    
                    <Modal
                    onCancel={()=>setOpenFile(false)}
                    style={{ width: '100wh', height: 500 }}
                        open={openfile}
                        footer={<><Button onClick={()=>setOpenFile(false)} >ปิด</Button></>}
                    >
                        {previewUrl ? (
                        <iframe
                            src={previewUrl}
                            width="100%"
                            height="600px"
                            title="PDF Viewer"
                        />
                        ) : (
                        <p>Loading...</p>
                        )}
                        
                    </Modal>
                    </List.Item>
                    )}
                />
            </>}
            <br/>
            {/* <h3 className="text-l">ข้อมูลผู้ร่วมวิจัย</h3> */}
            {/* ตาราง */}

            {checkexistparticipant &&
                <>
                <h3 className="text-l font-semibold" style={{marginBottom:10}}><u>ข้อมูลผู้ร่วมวิจัย</u></h3>
                <Tabs>
                {joinParticipant.map((data,index)=>(
              <Tabs.TabPane tab={`ผู้ร่วมวิจัยคนที่ ${index+1}`} key={index}>
                <Flex><p className='font-semibold'>รหัสผู้ร่วมวิจัย : </p>&nbsp;<p>{data.head_id}</p></Flex>
                <Flex><p className='font-semibold'>ชื่อผู้ร่วมวิจัย :</p>&nbsp;<p></p>&nbsp;<p> {data.head_name_th}</p></Flex>
                <Flex><p className='font-semibold'>สถานที่ทำงาน :</p>&nbsp;<p> {data.head_wp}</p></Flex>
                <Flex><p className='font-semibold'>สัดส่วนการเข้าร่วมโครงการวิจัย :</p>&nbsp;<p> {data.join_per}</p></Flex>
                <br/>
                <p className="font-semibold" style={{marginBottom:10}}><u>วุฒิการศึกษา</u></p>
                <Table columns={[
                        {
                          title: 'ระดับปริญญา',
                          dataIndex:'edu_level',
                          key: 'edu_level',
                          
                      },
                      {   title: 'วุฒิการศึกษา',
                          dataIndex: 'edu_qual',
                          key: 'edu_qual',
                          
                      },
                      {
                          title: 'สถาบันการศึกษา',
                          dataIndex:'edu_place',
                          key: 'edu_place',
                          
                      },
                      {
                        title: 'ปีที่สำเร็จการศึกษา',
                        dataIndex:'edu_year',
                        key: 'edu_year',
                        
                    },
                      {
                          title: 'ประเทศ',
                          dataIndex:'edu_country',
                          key: 'edu_country'
                          ,
                      },
                      ]} 
                      locale={{
                        emptyText: (
                          <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                        ),
                      }}
                      dataSource={JSON.parse(data.head_edu)}/>
                      <br/>
                    <p className="leading-relaxed font-semibold" style={{marginBottom:10}}><u>ประสบการณ์ในการวิจัย</u></p>
                    <Table columns={headexcolumns} dataSource={JSON.parse(data.head_res)}
                    locale={{
                        emptyText: (
                          <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                        ),
                      }}/>
                    <br/>
                    <p className="leading-relaxed font-semibold" style={{marginBottom:10}}><u>การตีพิมพ์เผยแพร่งานวิจัย / บทความทางวิชาการ </u></p>
                    <Table columns={academicHis} dataSource={JSON.parse(data.head_pub)}
                    locale={{
                        emptyText: (
                          <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                        ),
                      }}/>
                    <br/>
              </Tabs.TabPane>
            ))

            }</Tabs>
              </>
            }
            </div>
            <br/>
            
                <div
                id="part-3">
            <br/>
            <br/>
            <br/>

            

            <h2 className="text-2xl font-bold leading-relaxed">ส่วนที่ 3 รายละเอียดโครงการงานวิจัย
                {(editable)&&<a href={`/VRIIS/BudgetReqDetail/${ project_id }`}>
                <Button>เพิ่ม/แก้ไขข้อมูล</Button></a>||<Button disabled>เพิ่ม/แก้ไขข้อมูล</Button>}</h2>
            <br/><hr/><br/>
            <p className="leading-relaxed font-semibold"><u>ความสำคัญ / เหตุผล / ปัญหาที่สำคัญของงานวิจัย / นิยามศัพท์เฉพาะ</u></p>
            
            <Card className="transparent-border-card">
             <>
              <ROCKEditors
              myRef={importantRef}
              htmlBox={DataFirst?.[0]?.resolution ? DataFirst?.[0]?.resolution : "ยังไม่มีการกรอก"}
              toolstate={false}
              />
              </>
          <br/>
                
            </Card>

            <br/>
            <p className="leading-relaxed font-semibold" style={{marginBottom:15}}><u>วัตถุประสงค์ของงานวิจัย</u></p>
            <Card className="transparent-border-card">
            <ROCKEditors
              myRef={objectiveRef}
              htmlBox={DataFirst?.[0]?.objective_list ? DataFirst?.[0]?.objective_list : "ยังไม่มีการกรอก"}
              toolstate={false}
              />
            
            </Card>
            <br/>
            <p className="leading-relaxed font-semibold" style={{marginBottom:15}}><u>ประโยชน์ที่คาดว่าจะได้รับ</u></p>
            <Card className="transparent-border-card">
            <ROCKEditors
              myRef={benefitRef}
              htmlBox={DataFirst?.[0]?.benefit ? DataFirst?.[0]?.benefit : "ยังไม่มีการกรอก"}
              toolstate={false}
              />
            
                </Card>
            <p className="leading-relaxed font-semibold"><u>การทบทวนวรรณกรรมและผลงานวิจัยที่เกี่ยวข้อง</u></p>
            <Card className="transparent-border-card">
            <ROCKEditors
              myRef={literatureRef}
              htmlBox={DataFirst?.[0]?.literacy ? DataFirst?.[0]?.literacy : "ยังไม่มีการกรอก"}
              toolstate={false}
              />
            </Card>
            <p className="leading-relaxed font-semibold"><u>กรอบแนวคิดในการวิจัย</u></p>
            <Card className="transparent-border-card">
            <ROCKEditors
              myRef={IdeaRef}
              htmlBox={DataFirst?.[0]?.idea ? DataFirst?.[0]?.idea : "ยังไม่มีการกรอก"}
              toolstate={false}
              />
            </Card>
            <p className="leading-relaxed  font-semibold"><u>ระเบียบวิธีวิจัย</u></p>
            <Card className="transparent-border-card">
            <ROCKEditors
              myRef={ResearchRef}
              htmlBox={DataFirst?.[0]?.solution ? DataFirst?.[0]?.solution : "ยังไม่มีการกรอก"}
              toolstate={false}
              />
            </Card>
            <p className="leading-relaxed font-semibold" style={{marginBottom:15}}><u>ระยะเวลาทำการวิจัย</u></p>
            <Card style={{marginBottom:15}}>{DataFirst?.[0]?.period ? periodToString(DataFirst[0].period) : 'ยังไม่มีการกรอก'}</Card>
            <p className="leading-relaxed font-semibold" style={{marginBottom:15}}><u>แผนการดำเนินงานตลอดโครงการ</u></p>
            <Table 
            columns={[{
                title:'กิจกรรมในการวิจัย',
                dataIndex:'ActivityName',
                fixed: 'left',  
                width: 200,  
                className: 'fixed-column'
            },
            {
              title:'ระยะเวลาที่ทำกิจกรรม',
              children:monthcolumn(selectedmonth,endmonth,DataFirst?.[0]?.period? JSON.parse(DataFirst?.[0]?.period): [])
            },
            {
              title:'ร้อยละของกิจกรรมในโครงการ',
              dataIndex:'ActivityRatio',
              fixed: 'right',  
              width: 200, 
              className: 'fixed-column'
          },
        
        ]}
        style={{ backgroundColor: '#fff', padding: '20px' }}
        scroll={{ x: 'max-content' }}
        dataSource={DataFirst?.[0]?.activity ? JSON.parse(DataFirst[0].activity) : []}
        locale={{
            emptyText: (
              <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
            ),
              }}
            />
            <br/>
            <p className="leading-relaxed font-semibold"><u>อุปกรณ์การวิจัย</u></p>
            
            <p className="leading-relaxed font-semibold">อุปกรณ์ที่จำเป็นในงานวิจัย</p>
            <Table columns={[
                {
                    title:'อันดับที่',
                    dataIndex:'index',
                    width:'110px',
                    render: (_, record) => (
                        <>
                          <p>{record.index+1}</p>
                        </>
                      ),
                },{
                    title:'อุปกรณ์ที่ใช้',
                    dataIndex:'item'
                },
                
            ]} 
            locale={{
                emptyText: (
                  <Empty description="งานวิจัย/โครงการนี้ไม่มีอุปกรณ์ที่จำเป็นในงานวิจัย" /> // Default image with custom text
                ),
              }}
            dataSource={DataFirst?.[0]?.needed_item ? JSON.parse(DataFirst[0].needed_item) : []}/>
            <p className="leading-relaxed font-semibold">อุปกรณ์การวิจัยที่มีอยู่แล้ว</p>
            <Table columns={[
                {
                    title:'อันดับที่',
                    dataIndex:'index',
                    width:'110px',
                    render: (_, record) => (
                        <>
                          <p>{record.index+1}</p>
                        </>
                      ),
                },{
                    title:'อุปกรณ์ที่ใช้',
                    dataIndex:'item'
                },
                
            ]} 
            locale={{
                emptyText: (
                  <Empty description="งานวิจัย/โครงการนี้ไม่มีอุปกรณ์ที่ใช้และมีอยู่" /> // Default image with custom text
                ),
              }}
            dataSource={DataFirst?.[0]?.possesed_item ? JSON.parse(DataFirst[0].possesed_item) : []}/>
            
            </div>
            
                <div
                id="part-4">
            <br/>
            <br/>
            <br/>

            <h2 className="text-2xl font-bold leading-relaxed">ส่วนที่ 4 ผลลัพธ์และผลกระทบ 
              {(editable)&&<a href={`/VRIIS/BudgetReqResult/${ project_id }`}><Button>เพิ่ม/แก้ไขข้อมูล</Button></a>||<Button disabled>เพิ่ม/แก้ไขข้อมูล</Button>}</h2>
            <br/><hr/><br/>
            <p className="leading-relaxed font-semibold">ผลผลิตที่คาดว่าจะได้รับ</p>
            <br/>
            <Table columns={[
                {
                    title: 'ผลผลิต',
                    dataIndex:'Output_name',
                    key: 'Output_name'
                },
                {
                    title: 'ประเภทผลผลิต',
                    dataIndex:'Output_type',
                    key: 'Output_type'
                },
                {
                    title: 'รายละเอียดของผลผลิต',
                    dataIndex:'Output_description',
                    key: 'Output_description'
                },
                {
                    title: 'จำนวนนำส่ง',
                    dataIndex:'Output_amount',
                    key: 'Output_amount'
                },
                {
                    title: 'หน่วยนับ',
                    dataIndex:'Output_unit',
                    key: 'Output_unit'
                },
                ]}
                dataSource={Output}
                locale={{
                    emptyText: (
                      <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                    ),
                  }}
                />
            <br/>
            <p className="leading-relaxed font-semibold">ผลลัพธ์ที่คาดว่าจะเกิดขึ้น</p>
            <br/>
            <Table columns={[
                {
                    title: 'ผลลัพธ์ที่คาดว่าจะได้รับ',
                    dataIndex:'Outcome_name',
                    key: 'Outcome_name'
                },
                {
                    title: 'จำนวน',
                    dataIndex:'Outcome_amount',
                    key: 'Outcome_amount'
                },
                {
                    title: 'หน่วยนับ',
                    dataIndex:'Outcome_unit',
                    key: 'Outcome_unit'
                },
                {
                    title: 'รายละเอียดผลลัพธ์',
                    dataIndex:'Outcome_description',
                    key: 'Outcome_description'
                },
                {
                    title: 'ผู้ใช้ประโยชน์(Users)/ผู้ได้รับผลประโยชน์(Beneficiaries)',
                    dataIndex:'Outcome_Benefitor',
                    key: 'Outcome_Benefitor'
                },
                ]} 
                locale={{
                    emptyText: (
                      <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                    ),
                  }}
                dataSource={Outcome}
            ></Table>
            <br/>
            <p className="font-semibold"><u>ผลกระทบ</u></p>
            
            {Impacts?.academic_impacts&&<><p className='font-semibold'>ผลกระทบด้านวิชาการ : </p><p className='font-normal'>{Impacts.academic_impacts}</p></>}
            {Impacts?.social_impacts&&<><p className='font-semibold'>ผลกระทบด้านสังคม : </p><p className='font-normal'>{Impacts.social_impacts}</p></>}
            {Impacts?.public_impacts&&<><p className='font-semibold'>ผลกระทบด้านสาธารณะ : </p><p className='font-normal'>{Impacts.public_impacts}</p></>}
            {Impacts?.city_impacts&&<><p className='font-semibold'>ผลกระทบด้านชุมชนและพื้นที่ : </p><p className='font-normal'>{Impacts.city_impacts}</p></>}
            {Impacts?.environment_impacts&&<><p className='font-semibold'>ผลกระทบด้านสิ่งแวดล้อม : </p><p className='font-normal'>{Impacts.environment_impacts}</p></>}
            {Impacts?.policy_impacts&&<><p className='font-semibold'>ผลกระทบด้านนโยบาย : </p><p className='font-normal'>{Impacts.policy_impacts}</p></>}
            {Impacts?.economy_impacts&&<><p className='font-semibold'>ผลกระทบด้านเศรษฐกิจ : </p><p className='font-normal'>{Impacts.economy_impacts}</p></>}
            {!Impacts?.academic_impacts && 
             !Impacts?.social_impacts && 
             !Impacts?.public_impacts &&  
             !Impacts?.city_impacts && 
             !Impacts?.environment_impacts && 
             !Impacts?.policy_impacts && 
             !Impacts?.economy_impacts &&
             <>ยังไม่มีการกรอกข้อมูลผลกระทบ</>}
             </div>
             
             <div id="part-5">
            <br/>
            <br/>
            <br/>
            <h2 className="text-2xl font-bold leading-relaxed">ส่วนที่ 5 งบประมาณและค่าใช้จ่าย {(editable)&&<a href={`/VRIIS/BudgetReqFund/${ project_id }`}><Button>เพิ่ม/แก้ไขข้อมูล</Button></a>||<Button disabled>เพิ่ม/แก้ไขข้อมูล</Button>}</h2> 
            <br/><hr/><br/>
            <p className="leading-relaxed font-semibold">งบประมาณ</p>
            {DataFirst[0]?.budget_type!='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'&&<Table
                rowKey="id"
                columns={[
                  {
                    title: 'ลำดับที่',
                    width: 92,
                    dataIndex: 'id',
                    key: 'id',
                    render: (_, record) => (
                      <Flex justify="center">
                        <p>{record.id !== 4 ? record.id : ''}</p>
                      </Flex>
                    ),
                  },
                  {
                    title: 'รายละเอียดประมาณการค่าใช้จ่าย',
                    width: 450,
                    dataIndex: 'detail',
                    key: 'detail',
                  },
                  {
                    title: 'งบประมาณ',
                    width: 1000,
                    children: [
                      {
                        title: 'ตัวเงิน(เบิกจ่าย)',
                        width:200,
                        dataIndex: 'MonetrySum',
                        render: (_, record) => (
                          <Flex justify="center">{formatNumber(record.MonetrySum)}</Flex>
                        ),
                      },
                      {
                        title: 'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้',
                        dataIndex: 'PreparedSum',
                        width:200,
                        render: (_, record) => (
                          <Flex justify="center">{formatNumber(record.PreparedSum)}</Flex>
                        ),
                      },
                      {
                        title: 'ไม่เป็นตัวเงิน(งบอ้อม)',
                        dataIndex: 'IndirectSum',
                        width:200,
                        render: (_, record) => (
                          <Flex justify="center">{formatNumber(record.IndirectSum)}</Flex>
                        ),
                      },
                    ],
                  },
                  {
                    title: 'รวม',
                    width: 150,
                    dataIndex: 'sum',
                    render: (_, record) => (
                      <Flex justify="center">
                        {formatNumber(record.sum)}
                      </Flex>)
                  },
                  {
                    title: 'หมายเหตุ',
                    dataIndex: 'note',
                    key: 'note',
                  },
                ]}
                dataSource={BudgetTypeCol}
                expandable={{
                  expandedRowRender,
                  expandedRowKeys: Keys,
                  onExpand: handleExpand,
                  rowExpandable: (record) => {
                    if (record.category === 'compensation') return compensationItems.length > 0;
                    if (record.category === 'outcome') return OutcomeItems.length > 0;
                    if (record.category === 'itemexpense') return ItemCost.length > 0;
                    return false;
                  },
                }}
                pagination={false}
                locale={{
                  emptyText: <Empty description="ยังไม่มีข้อมูลในตาราง" />,
                }}
                scroll={{ x: 'max-content' }} // Enable horizontal scrolling
              />||
              <Card style={{backgroundColor: '#F7DCB9' }}>
                <Card style={{ marginLeft: 20, marginRight: 20, marginBottom: 25, backgroundColor: 'white', textAlign: 'center', }} >
                  <p>ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา จำนวน 10,000 บาท </p>
                </Card>
              </Card>}

            
            <br/>
            <p className="leading-relaxed font-semibold">บรรณานุกรม</p>
            <Card className="transparent-border-card">
                <JoditReact 
                value={DataFirst?.[0]?.reference ? DataFirst[0].reference : "ยังไม่มีการกรอก"} 
                config={config}
                />
            </Card>
            <p className="leading-relaxed font-semibold">ร่างเครื่องมือวิจัย</p>
            {toolDraft&& <>
                <p className="leading-relaxed">*ได้รับไฟล์แล้ว*</p>
                <List
                    bordered
                    dataSource={fileList}
                    renderItem={(file) => (
                        <List.Item
                    actions={[
                        <>
                        <Button type='link' onClick={() => DownloadHandle(file.uid)}>Download</Button>
                        </>
                    ]}
                    >
                    <Button type='link' 
                    onClick={() => handlePreview(file)}>{file.name}</Button>
                    
                    <Modal
                    onCancel={()=>setOpenFile(false)}
                    style={{ width: '100wh', height: 500 }}
                        open={openfile}
                        footer={<><Button onClick={()=>setOpenFile(false)} >ปิด</Button></>}
                    >
                        {previewUrl ? (
                        <iframe
                            src={previewUrl}
                            width="100%"
                            height="600px"
                            title="PDF Viewer"
                        />
                        ) : (
                        <p>Loading...</p>
                        )}
                        
                    </Modal>
                    </List.Item>
                    )}
                />
                </>||
            <p className="leading-relaxed" >*ไม่มีไฟล์ร่างเครื่องมือวิจัย*</p>
            }
            <br/>
            </div>
            <p className="leading-relaxed">สถานะของโครงการ</p>
            <Steps
              direction="vertical"
              progressDot
              current={status}
              status="finish"
              items={[
                ...[
                  {
                      title: 'แก้ไข',
                      description:'ยังอยู่ในขั้นตอนการลงข้อมูลและแก้ไขโดยผู้ยื่นเสนอ',
                  },
                  {
                      title: DataFirst[0].project_status === 'สั่งแก้ไขจากผู้บังคับบัญชาเบื้องต้น' 
                      ? 'สั่งแก้ไขจากผู้บังคับบัญชาเบื้องต้น' 
                      : 'รออนุมัติจากผู้บังคับบัญชาเบื้องต้น',
                      description:
                      <>รอผลตรวจสอบจากผู้บังคับบัญชาเบื้องต้น
                      {/* setheadcommenttext */}
                      {headComment && 
                      <Card>
                      <p className='font-semibold'>ข้อความจาก ผู้บังคับบัญชาเบื้องต้น</p>
                      <ROCKEditors
                        myRef={headCommentRef}
                        htmlBox={headCommenttext? headCommenttext : "ไม่มีเหตุผลประกอบ"}
                        toolstate={false}
                        />
                      <p>ลงข้อความเมื่อ {moment(headCommentdate).utc().format('DD/MM/YYYY HH:mm:ss')}</p>
                      <br/>
                      <hr/>
                      <br/>
                      {(status==1&&editable&&DataFirst[0].project_status=='สั่งแก้ไขจากผู้บังคับบัญชาเบื้องต้น')&&
                      <Form.Item label='ข้อความถึงผู้บังคับบัญชาเบื้องต้น' layout='vertical'>
                      <TextArea onChange={(e) => setResearcherComment(e.target.value)} autoSize/>
                      </Form.Item>}
                      </Card>}
                      </>,
                  },
                  {
                      title: DataFirst[0].project_status === 'สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย' 
                      ? 'สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย' 
                      : 'รออนุมัติจากเจ้าหน้าที่สำนักวิจัย',
                      description:<>รอผลตรวจสอบจากเจ้าหน้าที่
                      {
                        staffComment && <Card>
                          <p className='font-semibold'>ข้อความจาก เจ้าหน้าที่</p>
                          <ROCKEditors
                            myRef={staffCommentRef}
                            htmlBox={StaffCommenttext ? StaffCommenttext : "ไม่มีเหตุผลประกอบ"}
                            toolstate={false}
                            />
                          
                            <p >ลงข้อความเมื่อ {moment(StaffCommentDate).utc().format('DD/MM/YYYY HH:mm:ss')}</p>
                        </Card>
                      }
                      </>
                      ,
                  },
                  {
                      title: DataFirst[0].project_status === 'แก้ไขตามความเห็นของกรรมการ' 
                      ? 'สั่งแก้ไขตามความเห็นของกรรมการ' 
                      : 'ตรวจสอบตามความเห็นของกรรมการ',
                      description:
                      <>รอผลตรวจสอบจากคณะกรรมการ
                      {
                        showSumedit&& <Card>
                        <p>มีการสั่งแก้ไขจากคณะกรรมการดังนี้</p>
                        <Form form={Explanation}>
                          <Form.Item name='SumComment'
                            shouldUpdate noStyle>
                            <Table
                            columns={[{
                              title:'ข้อ',
                              dataIndex:'index',
                              render: (_: any, __: any, rowIndex: number) => (
                                <>{rowIndex + 1}</> // Add 1 to start the index from 1 instead of 0
                              )
                            },{
                              title:'หัวข้อ',
                              dataIndex:'topic',
                              width: '20vw'
                            },
                            // {
                            //   title: "ข้อเสนอแนะ",
                            //   dataIndex: "summary",
                            //   width: '20vw',
                            //   render: (text: string) => (
                            //     <span>
                            //       {text.split("\n").map((line, index) => (
                            //         <React.Fragment key={index}>
                            //           {line}
                            //           <br />
                            //         </React.Fragment>
                            //       ))}
                            //     </span>
                            //   ),
                            // },
                            {
                              title: "คำชี้แจงจากนักวิจัย",
                              dataIndex: "explanation",
                              render: (_: any, record: any, rowIndex: number) => (
                                <Form.Item
                                  name={['SumComment', rowIndex, 'explanation']}
                                  noStyle
                                >
                                  <TextArea placeholder="กรอกคำชี้แจง" autoSize />
                                </Form.Item>
                              ),
                            },
                          ]}
                            pagination={false}
                            dataSource={SumComment}
                            />
                          </Form.Item>
                        </Form>
                        <br/>
                        <Flex justify='center'>
                          <Button type='primary' onClick={()=>sendComment()}>
                            บันทึกชั่วคราว
                          </Button>
                        </Flex>
                      </Card>
                      }
                      </>,
                  },
                  {
                      title:  DataFirst[0].project_status === 'อนุมัติ' 
                      ? 'อนุมัติ' 
                      : 'ไม่อนุมัติ',
                      description:
                      <>ได้รับผลยืนยันจากทุกฝ่ายแล้ว
                      {
                        showSum && <Card>
                          <Table
                          columns={[{
                            title:'ข้อ',
                            dataIndex:'index',
                            render: (_: any, __: any, rowIndex: number) => (
                              <>{rowIndex + 1}</> // Add 1 to start the index from 1 instead of 0
                            )
                          },{
                            title:'หัวข้อ',
                            dataIndex:'topic'
                          },{
                            title:'ข้อเสนอแนะ',
                            dataIndex:'summary'
                          }
                        ]}
                          pagination={false}
                          dataSource={JSON.parse(SummaryComment)}
                          />
                          {/* <JoditReact
                            value={SummaryComment ? SummaryComment : "ไม่มีเหตุผลประกอบ"} 
                            config={config}/> */}
                        </Card>
                      }
                      </>,
                      
                  },
                  ]
                  .slice(0, status + 1) // Show only up to the current step
                  .reverse()]} // Reverse the order of steps
            />

            <br/>
            {/* ตาราง */}
            
            
            <Flex justify="center"><a href="/VRIIS"><Button type="primary">กลับสู่หน้าหลัก</Button></a></Flex>
            <br/>

            
            
            { DataFirst[0].project_status=='แก้ไข' &&<Alert message="กรุณาตรวจสอบข้อมูลก่อนยื่นโครงการของท่าน เมื่อโครงการท่านถูกยื่นขออนุมัติแล้วจะไม่สามารถแก้ไขได้อีกเว้นแต่ทางสำนักงานงานวิจัยจะแจ้งให้ท่านแก้ไข" type="error" />}
            <br/>
            {(!part2||!part3||!part4||!part5||!fundpart)&&<><Card><p>คำเตือน</p>
            <p>ทางระบบได้ตรวจพบว่าท่านยังกรอกข้อมูลในระบบไม่ครบถ้วน กรุณากรอกข้อมูลในส่วนต่อไปนี้</p>
              <br/>
              <Card style={{backgroundColor:'#F54841'}}>
                <p className='font-semibold' style={{color:'white'}}><u>ข้อมูลส่วนที่ยังไม่ถูกกรอก</u></p>
                {!part2&&<p style={{marginLeft:20,color:'white'}}>- ส่วนที่ 1 ข้อมูลงานวิจัย</p>}
                {!part3&&<p style={{marginLeft:20,color:'white'}}>- ส่วนที่ 2 ข้อมูลบุคลากรที่เกี่ยวข้องกับงานวิจัย</p>}
                {!part4&&<p style={{marginLeft:20,color:'white'}}>- ส่วนที่ 3 รายละเอียดโครงการงานวิจัย</p>}
                {!part5&&<p style={{marginLeft:20,color:'white'}}>- ส่วนที่ 4 ผลลัพธ์และผลกระทบ</p>}
                {!fundpart&&<p style={{marginLeft:20,color:'white'}}>- ส่วนที่ 5 งบประมาณและค่าใช้จ่าย</p>}
                
              </Card>
              </Card>
            </>}
            <br/>
            {joinper!=100&&<Card style={{backgroundColor:'#F54841'}}>
              <Flex><p className='font-semibold' style={{color:'white'}}><u>คำเตือน</u></p> &nbsp; <p></p>
              <p style={{color:'white'}}>ขณะนี้มีสัดส่วนการเข้าร่วมโครงการวิจัยทั้งหมด {joinper} เปอร์เซ็น</p>
              </Flex>
              <p style={{color:'white'}}>ท่านจะไม่สามารถยื่นเสนอโครงการวิจัยหากสัดส่วนการเข้าร่วมโครงการวิจัยของท่านไม่ครบ 100 เปอร์เซ็นต์</p>
              <p style={{color:'white'}}>กรุณาแก้ไขข้อมูลในส่วนที่สองเพื่อให้สามารถยื่นโครงการวิจัยได้</p>
            </Card>
            }<br/>
            <Flex justify="center">
            {
                successprogress === 100 &&
                joinper === 100 &&
                ![
                  'อนุมัติ',
                  'ไม่อนุมัติ',
                  'รอตรวจสอบจากผู้บังคับบัญชาเบื้องต้น',
                  'รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย',
                  'รอผลอนุมัติจากคณะกรรมการ',
                  'รอการตรวจสอบผลอนุมัติจากกรรมการ',
                ].includes(DataFirst[0]?.project_status) ? (
                  <Button
                    type="primary"
                    style={{ backgroundColor: '#33b249', color: 'white', borderColor: '#33b249' }}
                    onClick={() => setopenMod(true)}
                  >
                    ยื่นขอพิจารณา
                  </Button>
                ) : <>{DataFirst[0]?.project_status === 'อนุมัติ' && (
                  <Flex justify='center'><Button onClick={()=>{handleSetEditor()}}>สร้างไฟล์ PDF / WORD</Button></Flex>
                )||(
                  <Button type="primary" disabled>
                    ยื่นขอพิจารณา
                  </Button>
                )}</>
              }

              </Flex>
        </div>}
             
        <Modal
        title="ยืนยันการอนุมัติ"
        open={openMod}
        onCancel={()=>setopenMod(false)}
        footer={[
          <><Button key="back" onClick={()=>setopenMod(false)}>
              กลับ
          </Button><Button type='primary' style={{ backgroundColor: '#33b249', color: 'white', borderColor: '#33b249' }} onClick={() => send()}>
              ใช่
          </Button></>
        ]}
      >
        คุณต้องการยื่นขออนุมัติทุนหรือไม่
        </Modal>

        <Modal
        title={
          <Flex justify="space-between" align="center" gap={12}>
            <div>
              <div
                style={{
                  fontSize: 18,
                  fontWeight: 600,
                  lineHeight: 1.2,
                }}
              >
                ตัวอย่างข้อมูลในไฟล์
              </div>

              <div
                style={{
                  fontSize: 13,
                  color: "#8c8c8c",
                  marginTop: 4,
                  fontWeight: 400,
                }}
              >
                ตรวจสอบข้อมูลก่อน Export เป็น PDF หรือ DOCX
              </div>
            </div>

            <Space>
              <Button
                onClick={async (e) => {
                  e.stopPropagation();

                  try {
                    await exportHtmlToPdf(exportdata, {
                      fileName: `${DataFirst[0].project_name_th}.pdf`,
                    });

                    message.success("Export PDF สำเร็จ");
                  } catch (error) {
                    console.error(error);
                    message.error("Export PDF ไม่สำเร็จ");
                  }
                }}
                disabled={PreviewLoading || !exportdata}
              >
                Export PDF
              </Button>

              <Button
                type="primary"
                onClick={async (e) => {
                  e.stopPropagation();

                  try {
                    await exportHtmlToDocx(exportdata, {
                      fileName:  `${DataFirst[0].project_name_th}.docx`,
                    });

                    message.success("Export DOCX สำเร็จ");
                  } catch (error) {
                    console.error(error);
                    message.error("Export DOCX ไม่สำเร็จ");
                  }
                }}
                disabled={PreviewLoading || !exportdata}
              >
                Export DOCX
              </Button>
            </Space>
          </Flex>
        }
        open={preview}
        width="70vw"
        styles={{
          body: {
            maxHeight: "70vh",
            overflowY: "auto",
            padding: 20,
            background: "#fafafa",
          },
        }}
        onCancel={() => setPreview(false)}
        footer={null}
      >
        <LoadingOverlay
          active={PreviewLoading}
          spinner
          text="กำลังโหลดข้อมูล"
        >
          <div
            style={{
              background: "#fff",
              border: "1px solid #f0f0f0",
              borderRadius: 12,
              padding: 16,
            }}
          >
            <CKEditors
              myRef={htmlpage}
              htmlBox={exportdata}
              toolstate={true}
            />
          </div>
        </LoadingOverlay>
      </Modal>
        
        </>
    )
}